import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.iterator.some.js";
import "core-js/modules/es.set.difference.v2.js";
import "core-js/modules/es.set.intersection.v2.js";
import "core-js/modules/es.set.is-disjoint-from.v2.js";
import "core-js/modules/es.set.is-subset-of.v2.js";
import "core-js/modules/es.set.is-superset-of.v2.js";
import "core-js/modules/es.set.symmetric-difference.v2.js";
import "core-js/modules/es.set.union.v2.js";
import axios from "axios";
import moment from "moment";
import * as XLSX from "xlsx";


import { ElLoading } from 'element-plus/es';
import 'element-plus/es/components/base/style/css';
import 'element-plus/es/components/loading/style/css';
/** 耗时日志仅当超过该毫秒数才输出（与 home.vue 一致） */
const SLOW_STEP_LOG_MS = 500;
export default {
  data() {
    return {
      institution: sessionStorage.getItem("institution"),
      username: "",
      zoom: sessionStorage.getItem("zoom"),
      courseOptions: JSON.parse(sessionStorage.getItem("courseOptions")),
      courseColor: JSON.parse(sessionStorage.getItem("courseColor")),
      lightColor: {
        "#ff6086": "#ffedf0",
        "#2651ff": "#e4e9ff",
        "#fd9f02": "#fff4e4",
        "#09bd3c": "#e2f2e6",
        "#007bff": "#e2f1ff"
      },
      // 选择的月份
      selectedMonth: "",
      // 选择的月份 有哪些日，是周几
      monthDates: [],
      // 当天日期
      todayDate: "",
      currentMonth: "",
      // 简洁视图 按钮
      selectConciseClassArrange: false,
      // 每周 哪些时间段展示
      weekPeriodShow: [{}, {}, {}, {}, {}, {}, {}],
      //班级列表
      classList: [],
      oriClassList: [],
      //classId转换为className
      classNames: {},
      //选择的班级
      selectedClassIndex: 0,
      //切换班级
      showChooseClass: false,
      // 搜索班级名
      searchStr: "",
      showSearchResult: false,
      //班级课表
      courseArrangeList: {},
      // 拖动排课
      dragStartIndexs: [],
      dragStartDate: "",
      dragStartCourseObject: {},
      mouseOnCourseCell: false,
      //判断课程和时间段的时间长度是否一致
      showTimeisDifferent: false,
      timeisDifferentWord: "",
      //老师有冲突
      showChangeTeacher: false,
      //教室有冲突
      showChangeClassroom: false,
      ifChangeClassroom: false,
      //ctrl-c排课
      ctrlcIndexs: [],
      //是move还是copy
      addCourseArrangeFlag: "",
      //移到哪个课，才显示删除按钮
      showDeleteCourseArrangeButtonIndexStr: "",
      //删除排课 弹窗
      showDeleteCourseArrange: false,
      deleteCourseArrangeIndexs: [],
      //添加班级
      showAddClass: false,
      //modify表示修改班级
      addClassTag: "",
      //班级名称
      className: "",
      //开班日期
      selectedStartDate: "",
      //结班日期
      selectedEndDate: "",
      //开班和结班日期
      selectedDateRange: [],
      //总课时
      totalClassHour: "",
      //老师列表
      teacherList: [],
      // teacherId转换为teacherName
      teacherNames: {},
      //选择的任课老师id
      selectedTeacherIds: [],
      //选择的任课老师，可以教的科目
      teachersCourseList: [],
      //选择的科目
      selectedCourses: [],
      //班级类型
      // courseTypes: ["一对一", "一对二", "班课"],
      courseTypes: JSON.parse(sessionStorage.getItem("courseTypeOptions")),
      selectedCourseType: "",
      //课时设置
      timeRange: [],
      startTime: "",
      endTime: "",
      selectedPeriods: [],
      selectedTimeRangeStr: "",
      timePickerFocus: false,
      enterTimeRangeShowPage: false,
      showSelectedTimeRange: false,
      //上课校区
      campusList: JSON.parse(sessionStorage.getItem("campusList")),
      //教室id转教室名
      classroomNames: {},
      selectedCampusId: "",
      //备注
      remark: "",
      // 设置科目单价
      ifTeacherCourseTypeSetFee: {},
      showSetFee: false,
      colorOptions: ["#ff6086", "#2651ff", "#fd9f02", "#09bd3c", "#007bff"],
      //双击单元格，排课页面
      showCourseArrangeStep1: false,
      selectedDate: "",
      selectedWeekday: "",
      selectedPeriod: "",
      // 老师是否有空
      teacherIdListAvailable: {},
      selectedTeacherId: "",
      //选择的任课老师 在这个班级 教的科目
      teacherClassCourseList: [],
      selectedCourse: "",
      //教室是否可用
      classroomIfAvailable: {},
      //选择的教室id
      selectedClassroomId: "",
      // 框选 批量删除
      isSelecting: false,
      selectionBox: null,
      startX: 0,
      startY: 0,
      div1Element: null,
      selectedElements: [],
      showDeleteMultipleCourseConfirm: false,
      // 三个点 更多功能
      showMoreFunction: false,
      // 班级排课详情
      showClassDetail: false,
      // 快速排课开关
      selectQuickArrangeCourse: false,
      // 快速排课的日期时间段
      quickArrangeDateRange: [],
      //选择了周一到周日哪些天
      selectedWeekdays: [],
      selectedAllWeekdays: false,
      weekdays: ["周一", "周二", "周三", "周四", "周五", "周六", "周日"],
      //周一到周日，时间段是否全选
      selectedAllPeriod: [false, false, false, false, false, false, false],
      //周一到周日选择的时间段
      selectedWeekdayPeriods: [[], [], [], [], [], [], []],
      //快速排课页面
      showCourseArrangeStep2: false,
      //选择的快速排课的 日期段内
      //每个日期，每个时间段，每个老师id，是否可排课
      datePeriodTeacherIfAvailable: {},
      //周一到周日，每个时间段，每个老师id，可排课数
      weekdayPeriodTeacherAvailableNum: [],
      // 周一到周日，每个时间段，每个老师id，是否选中
      weekdayPeriodTeacherIfSelected: [],
      // 周一到周日，每个时间段，每个老师id，是否可选（被置灰就无法选）
      ifCanSelectWeekdayPeriodTeacher: [],
      //每个日期，每个时间段是否可安排老师上课（班级课程，教室都没冲突）
      datePeriodIfAvailable: {},
      // 实时 每个日期，每个时间段的排课
      datePeriodArrangement: {},
      oriDatePeriodArrangement: {},
      // 实时 每个老师，这个日期这个时间段是否可排课
      teacherDatePeriodIfAvailable: {},
      oriTeacherDatePeriodIfAvailable: {},
      // 每个老师 可排课次数合计
      // {teacherId: 10}
      teacherAvailableNum: {},
      //快速排课分配 添加课程弹窗
      showAddTeacherQuickArrangeCourse: false,
      teacherQuickArrangeCourseName: "",
      quickArrangeTeacherId: 0,
      //每个老师 每个科目 安排的次数
      //teacherId: [{科目名：次数}, {科目名：次数}]
      teacherCourseArrangeNum: {},
      // 每个老师 每个科目 最大可排课次数
      //teacherId: [次数，次数]
      teacherCourseAvailableNum: {},
      //快速排课 结果预览
      showQuickArrangePreview: false,
      monthDates: [],
      quickArrangeCourseList: {},
      //展示 班级/老师/学生 课表
      showWhichCourseTable: "class",
      // 老师课表 相关
      //选择的老师
      selectedTeacherIndex: "无老师",
      //选择的日期
      teacherCourseSelectedDateIndex: 0,
      // {date: period: {}}
      teacherCourseArrangeList: {},
      showTeacherCourseTableNew: true,
      teacherPeriodList: [],
      // teacherId: date: [startTime, endTime]
      vacationList: {},
      //老师排课弹窗
      showTeacherAddCourse: false,
      //选择班级
      teacherClasses: {},
      selectedClassId: "",
      // 选择科目
      selectedCourse: "",
      //选择时间段
      teacherPeriodIsFree: {},
      selectedPeriod: "",
      // 选择教室
      selectedClassroomId: "",
      // 老师批量调课
      showQuickMoveTeacherCourse: false,
      quickMoveTeacherCourseStartDate: "",
      quickMoveTeacherCourseEndDate: "",
      realEndDate: "",
      // 选择的日期段，老师的班级，科目
      // classId: course: [{}, {}]
      teacherClassCourses: {},
      // 选择的班级和科目
      quickMoveTeacherCourseSelectedClassIdAndCourse: "",
      //可移到的老师列表
      moveToTeacherList: [],
      moveToTeacherId: 0,
      //isConflict字段表示能否移动
      courseIfCanMove: [],
      courseCanMove: [],
      courseCannotMove: [],
      // 移到的老师课程预览
      // {date: {period: {}}}
      moveToTeacherCourseArrangeList: {},
      oriMoveToTeacherCourseArrangeList: {},
      // 移给老师的课程数
      moveToTeacherCourseNum: 0,
      ifAssignRest: true,
      // 剩余待分配课程数
      moveToTeacherRestNum: 0,
      // 剩余课次分配
      showQuickMoveTeacherCourseStep2: false,
      teacherRestCourseMoveStartDate: "",
      teacherRestCourseMoveEndDate: "",
      quickMoveTeacherCourseSelectedClassId: "",
      quickMoveTeacherCourseSelectedCourse: "",
      classWeekdays: [],
      classPeriods: [],
      weekdayPeriodIfSelected: [[], [], [], [], [], [], []],
      // 合计
      weekdayAvailable: [0, 0, 0, 0, 0, 0, 0],
      // 分配的
      weekdayAssign: [0, 0, 0, 0, 0, 0, 0],
      // 下拉框最大值
      weekdayAvailableRest: [0, 0, 0, 0, 0, 0, 0],
      // 学生课表
      studentList: [],
      studentNames: {},
      selectedStudentIndex: "无学生",
      studentCourseArrangeList: {},
      studentPeriodIsFree: {},
      // 学生 一对一排课 弹窗
      showStudentAddCourse: false,
      studentOneToOneClasses: [],
      showMountStudent: false,
      mountStudentIds: [],
      mountStudentNames: [],
      mountStudentSearchStr: "",
      editingParentPhoneStudentId: null,
      newParentPhone: "",
      parentPhoneSaving: false,
      // 导出班级课表 弹窗
      showExportClassCourseArrangeDateRange: false,
      exportClassCourseArrangeDateRange: [],
      exportClassCourseArrangeStartDate: "",
      exportClassCourseArrangeEndDate: "",
      // 提示弹窗 回调函数
      tipResolver: null,
      // 提示弹窗
      showTip: false
    };
  },
  async mounted() {
    console.log("\nEnter page /courseArrange");
    const mountT0 = performance.now();
    let stepT0 = mountT0;
    const logStep = label => {
      const t = performance.now();
      const dt = t - stepT0;
      if (dt > SLOW_STEP_LOG_MS) {
        console.log(`[courseArrange mounted] ${label}: ${dt.toFixed(1)}ms (>${SLOW_STEP_LOG_MS}ms)`);
      }
      stepT0 = t;
    };
    let userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
    this.username = userInfo.name;
    logStep("读取 userInfo & 设置 username");

    // 初始化时显示固定行列
    // this.$refs.fixedHeader.style.display = "block";
    // this.$refs.fixedColumn.style.display = "block";

    //初始获取当前月份
    const now = new Date();
    const currentYear = now.getFullYear();
    const selectedMonth = String(now.getMonth() + 1).padStart(2, "0");
    this.selectedMonth = `${currentYear}-${selectedMonth}`;
    logStep("初始化 selectedMonth");

    // 获取选择的月份 有多少天, 是星期几
    this.getMonthInfo();
    logStep("getMonthInfo");

    // // 获取科目清单，科目颜色
    // await this.getCourseOptions();
    // logStep("getCourseOptions");
    if (!this.courseOptions || !this.courseColor) {
      await this.getCourseOptions();
    }
    logStep("getCourseOptions");
    await Promise.all([
    // 获取班级列表，已排课时
    this.getClassList(),
    // logStep("getClassList");

    //获取老师列表(筛选出启用的)
    this.getTeacherList(),
    // logStep("getTeacherList");

    // 查询校区
    this.queryCampus(),
    // logStep("queryCampus（含已缓存跳过）");

    // 获取学生列表
    this.getStudentList()
    // logStep("getStudentList");
    ]);
    logStep("获取班级、老师、校区、学生");

    // 校区的教室
    this.classroomNames = {};
    for (let i = 0; i < this.campusList.length; i++) {
      for (let j = 0; j < this.campusList[i].classrooms.length; j++) {
        this.classroomNames[this.campusList[i].classrooms[j].id] = this.campusList[i].classrooms[j].name;
      }
    }
    // console.log("this.classroomNames:", this.classroomNames);
    logStep("构建 classroomNames");
    await Promise.all([(async () => {
      const t0 = performance.now();
      if (this.classList.length > 0) {
        // 获取班级的课程安排
        await this.getClassCourseArrange();
      }
      const dtClassArr = performance.now() - t0;
      if (dtClassArr > SLOW_STEP_LOG_MS) {
        console.log(`[courseArrange mounted] getClassCourseArrange（含跳过）用时: ${dtClassArr.toFixed(1)}ms (>${SLOW_STEP_LOG_MS}ms)`);
      }
    })(), (async () => {
      const t0 = performance.now();
      if (this.teacherList.length > 0) {
        this.selectedTeacherIndex = 0;

        // 获取老师的课程安排
        await this.getTeacherCourseArrange();
      }
      const dtTeacherArr = performance.now() - t0;
      if (dtTeacherArr > SLOW_STEP_LOG_MS) {
        console.log(`[courseArrange mounted] getTeacherCourseArrange（含跳过）用时: ${dtTeacherArr.toFixed(1)}ms (>${SLOW_STEP_LOG_MS}ms)`);
      }
    })(), (async () => {
      if (this.teacherList.length > 0) {
        // 获取假期
        await this.queryVacation();
      }
    })(), (async () => {
      if (this.studentList.length > 0) {
        this.selectedStudentIndex = 0;

        // 获取学生的课程安排
        await this.getStudentCourseArrange();
      }
    })()]);
    logStep("并行：classCourseArrange / teacherCourseArrange / vacation / studentCourseArrange");

    //等待页面渲染完成
    await this.$nextTick();
    logStep("$nextTick");

    //今天的日期
    this.todayDate = this.selectedMonth + "-" + now.getDate().toString().padStart(2, "0");
    this.currentMonth = this.todayDate.split("-")[0] + "-" + this.todayDate.split("-")[1];
    //今天是这个月第几天
    let todayIndex = 0;
    for (let i = 0; i < this.monthDates.length; i++) {
      if (this.monthDates[i].completeDate === this.todayDate) {
        todayIndex = i;
        this.teacherCourseSelectedDateIndex = parseInt(JSON.stringify(i));
        break;
      }
    }
    //滚动条自动把这天放最上面
    if (this.classList.length > 0 && this.classList[this.selectedClassIndex].periods) {
      const scrollTop = Math.floor(todayIndex / 7) * (100 + this.classList[this.selectedClassIndex].periods.length * 80);
      const scrollContainer = document.getElementById("scrollArea");
      if (scrollContainer) {
        scrollContainer.scrollTop = scrollTop;
      }
    }

    // 下拉框 弹框 宽度设置
    // 某个
    // let teacherSelectClassElement = document.querySelector(
    //   ".teacherSelectClass .el-select-dropdown"
    // );
    // console.log("teacherSelectClassElement:", teacherSelectClassElement);
    // console.log(
    //   "teacherSelectClassElement.style.minWidth:",
    //   teacherSelectClassElement.style.minWidth
    // );
    // 所有的
    let selectDropdownElement = document.querySelectorAll(".el-select-dropdown");
    // console.log("selectDropdownElement:", selectDropdownElement);
    for (let element of selectDropdownElement) {
      // 取消下拉框 弹框 minWidth属性，使下拉框宽度自适应
      element.style.minWidth = "";

      // 设置下拉框 弹框 最大高度，超过滚动
      // element.style.maxHeight = "100px";
      element.style.overflowY = "auto";
    }
    logStep("下拉框样式调整");

    // 框选 批量删除 功能
    this.div1Element = document.getElementById("div1");
    if (this.div1Element) {
      this.div1Element.addEventListener("mousedown", this.handleMouseDown);
    }
    logStep("绑定 mousedown 事件");
    const dtMountAll = performance.now() - mountT0;
    if (dtMountAll > SLOW_STEP_LOG_MS) {
      console.log(`[courseArrange mounted] 总用时: ${dtMountAll.toFixed(1)}ms (>${SLOW_STEP_LOG_MS}ms)`);
    }
  },
  beforeUnmount() {
    if (this.div1Element) {
      this.div1Element.removeEventListener("mousedown", this.handleMouseDown);
    }
  },
  computed: {
    mountStudentRows() {
      const selectedClass = this.classList[this.selectedClassIndex] || {};
      const realMountStudentIds = this.normalizeIdArray(selectedClass.mountStudentIds);
      return this.mountStudentIds.map(studentId => {
        const student = this.studentList.find(item => item.id == studentId);
        if (!student) {
          return {
            id: studentId,
            name: this.studentNames[studentId] || studentId,
            phones: [],
            canUnmount: realMountStudentIds.some(id => id == studentId)
          };
        }
        const phones = [];
        if (student.phone) {
          phones.push({
            value: student.phone,
            type: "student"
          });
        }
        this.getStudentParentPhones(student).filter(phone => phone !== student.phone).forEach(phone => {
          phones.push({
            value: phone,
            type: "parent"
          });
        });
        return {
          id: student.id,
          name: student.name,
          phones,
          canUnmount: realMountStudentIds.some(id => id == student.id)
        };
      }).filter(student => student.id);
    },
    filteredMountStudentOptions() {
      const keyword = this.mountStudentSearchStr.trim().toLowerCase();
      if (!keyword) {
        return [];
      }
      return this.studentList.filter(student => {
        if (this.mountStudentIds.some(id => id == student.id)) {
          return false;
        }
        return [student.name, student.phone, ...this.getStudentParentPhones(student)].filter(Boolean).some(value => String(value).toLowerCase().includes(keyword));
      }).slice(0, 20);
    }
  },
  methods: {
    // 获取老师参与的班级
    async getTeacherClass() {
      const loading = ElLoading.service({
        lock: true,
        text: "处理中...",
        background: "rgba(0, 0, 0, 0.7)"
      });
      try {
        let teacherIds = [];
        for (let i in this.teacherList) {
          teacherIds.push(this.teacherList[i].id);
        }
        let params = {
          teacherIds: teacherIds
        };
        let resp1 = await axios.post("https://backend.wonology.com/courseArrange/courseArrange/getTeacherClass", params);
        if (resp1.data.code == "0000") {
          this.teacherClasses = resp1.data.data;

          // console.log("this.teacherClasses:", this.teacherClasses);
        } else {
          console.log("调用getTeacherClass出错:", resp1.data.msg);
          alert("调用后端出错: " + resp1.data.msg);
        }
      } catch (error) {
        console.log("调用后端出错:", error);
        alert("调用后端出错: " + error);
      } finally {
        loading.close();
      }
    },
    // 获取科目清单，科目颜色
    async getCourseOptions() {
      //loading界面
      const loading = ElLoading.service({
        lock: true,
        text: "处理中...",
        background: "rgba(0, 0, 0, 0.7)"
      });
      try {
        let params = {
          institution: this.institution
        };
        let resp1 = await axios.post("https://backend.wonology.com/courseArrange/teacherAndCourse/queryCourses", params);
        if (resp1.data.code == "0000") {
          if (resp1.data.data) {
            this.courseOptions = JSON.parse(resp1.data.data[0].courses);
            this.courseColor = JSON.parse(resp1.data.data[0].courseColor);
            if (!this.courseColor) {
              this.courseColor = {};
            }
            sessionStorage.setItem("courseOptions", JSON.stringify(this.courseOptions));
            sessionStorage.setItem("courseColor", JSON.stringify(this.courseColor));
          }
        } else {
          console.log("调用后端出错:", resp1.data.msg);
          alert("调用后端出错: " + resp1.data.msg);
        }
      } catch (error) {
        console.log("catch error:", error);
        alert("catch error: " + error);
      } finally {
        loading.close();
      }
    },
    // 获取班级列表
    async getClassList(needCalculateArrangedHour, classId) {
      //loading界面
      const loading = ElLoading.service({
        lock: true,
        text: "处理中...",
        background: "rgba(0, 0, 0, 0.7)"
      });
      try {
        let params = {
          institution: this.institution,
          needCalculateArrangedHour: needCalculateArrangedHour,
          classId: classId
        };
        let resp1 = await axios.post("https://backend.wonology.com/courseArrange/courseArrange/getClassList", params);
        if (resp1.data.code == "0000") {
          this.classList = resp1.data.data;

          // 部分字段json.parse()
          for (let i in this.classList) {
            this.classList[i].teacherIds = JSON.parse(this.classList[i].teacherIds);
            // 将 teacherId 倒序排列
            this.classList[i].teacherIds.sort((a, b) => b - a);
            this.classList[i].courses = JSON.parse(this.classList[i].courses);
            this.classList[i].periods = JSON.parse(this.classList[i].periods);

            // 时间段正序排序（先比开始时间，再比结束时间）
            this.classList[i].periods.sort((a, b) => {
              const [aStart, aEnd] = a.split("-");
              const [bStart, bEnd] = b.split("-");
              const c = aStart.localeCompare(bStart);
              if (c !== 0) return c;
              return aEnd.localeCompare(bEnd);
            });
            if (this.classList[i].mountStudentIds) {
              this.classList[i].mountStudentIds = JSON.parse(this.classList[i].mountStudentIds);
            } else {
              this.classList[i].mountStudentIds = [];
            }
          }
          this.oriClassList = JSON.parse(JSON.stringify(this.classList));

          // console.log("获取班级列表 this.classList:", this.classList);

          // classId转换为className
          for (let i = 0; i < this.classList.length; i++) {
            this.classNames[this.classList[i].id] = this.classList[i].name;
          }
        } else {
          console.log("调用后端出错:", resp1.data.msg);
          alert("调用后端出错: " + resp1.data.msg);
        }
      } catch (error) {
        console.log("catch error:", error);
        alert("catch error " + error);
      } finally {
        loading.close();
      }
    },
    //获取老师列表(筛选出启用的)
    async getTeacherList() {
      //loading界面
      const loading = ElLoading.service({
        lock: true,
        text: "处理中...",
        background: "rgba(0, 0, 0, 0.7)"
      });
      try {
        let params = {
          institution: this.institution
        };
        let resp1 = await axios.post("https://backend.wonology.com/courseArrange/teacherAndCourse/getTeacherList", params);
        if (resp1.data.code == "0000") {
          this.teacherList = resp1.data.data;
          for (let i in this.teacherList) {
            this.teacherList[i].courses = this.teacherList[i].coursesStr.split("/");
          }

          // console.log("获取老师列表 this.teacherList:", this.teacherList);

          this.teacherNames = {};
          for (let i = 0; i < this.teacherList.length; i++) {
            this.teacherNames[this.teacherList[i].id] = this.teacherList[i].name;
          }
        } else {
          console.log("调用后端出错:", resp1.data.msg);
          alert("调用后端出错: " + resp1.data.msg);
        }
      } catch (error) {
        console.log("catch error:", error);
        alert("catch error " + error);
      } finally {
        loading.close();
      }
    },
    // 查询校区
    async queryCampus() {
      //loading界面
      const loading = ElLoading.service({
        lock: true,
        text: "处理中...",
        background: "rgba(0, 0, 0, 0.7)"
      });
      try {
        let params = {
          institution: this.institution
        };
        let resp1 = await axios.post("https://backend.wonology.com/courseArrange/campus/queryCampus", params);
        if (resp1.data.code == "0000") {
          // console.log("获取校区:", resp1.data.data);

          this.campusList = resp1.data.data;
          sessionStorage.setItem("campusList", JSON.stringify(resp1.data.data));
        } else {
          console.log("调用后端出错:", resp1.data.msg);
          alert("调用后端出错: " + resp1.data.msg);
        }
      } catch (error) {
        console.log("catch error:", error);
        alert("catch error: " + error);
      } finally {
        loading.close();
      }
    },
    //获取班级的课程安排
    async getClassCourseArrange(dateRange) {
      //loading界面
      const loading = ElLoading.service({
        lock: true,
        text: "处理中...",
        background: "rgba(0, 0, 0, 0.7)"
      });
      try {
        let params = {
          classId: this.classList[this.selectedClassIndex].id,
          startDate: this.monthDates[0].completeDate,
          endDate: this.monthDates[this.monthDates.length - 1].completeDate
        };
        // 如果传了日期范围，则使用传入的日期范围
        if (dateRange) {
          params.startDate = dateRange[0];
          params.endDate = dateRange[1];
        }
        let resp1 = await axios.post("https://backend.wonology.com/courseArrange/courseArrange/getClassCourseArrange", params);
        if (resp1.data.code == "0000") {
          // 如果指定了日期范围，直接返回数据，不给this全局变量赋值
          if (dateRange) {
            return resp1.data.data;
          } else {
            this.courseArrangeList = resp1.data.data;
          }

          // console.log("this.courseArrangeList:", this.courseArrangeList);
        } else {
          console.log("调用getClassCourseArrange出错:", resp1.data.msg);
          alert("调用后端出错: " + resp1.data.msg);
        }
      } catch (error) {
        console.log("catch error:", error);
        alert("catch error " + error);
      } finally {
        loading.close();
      }
    },
    //获取老师的课程安排
    async getTeacherCourseArrange(dateRange) {
      //loading界面
      const loading = ElLoading.service({
        lock: true,
        text: "处理中...",
        background: "rgba(0, 0, 0, 0.7)"
      });
      try {
        let params = {
          teacherId: this.teacherList[this.selectedTeacherIndex].id,
          startDate: this.monthDates[0].completeDate,
          endDate: this.monthDates[this.monthDates.length - 1].completeDate,
          institution: this.institution
        };
        // 如果传了日期范围，则使用传入的日期范围
        if (dateRange) {
          params.startDate = dateRange[0];
          params.endDate = dateRange[1];
        }
        let resp1 = await axios.post("https://backend.wonology.com/courseArrange/courseArrange/getTeacherCourseArrange", params);
        if (resp1.data.code == "0000") {
          this.teacherCourseArrangeList = resp1.data.data;

          // console.log(
          //   "this.teacherCourseArrangeList:",
          //   this.teacherCourseArrangeList
          // );

          // 得出老师的排课，有哪些时间段
          this.teacherPeriodList = [];
          for (let date in this.teacherCourseArrangeList) {
            for (let period in this.teacherCourseArrangeList[date]) {
              // 如果包含时间段，跳过
              if (this.teacherPeriodList.includes(period)) {
                continue;
              }
              this.teacherPeriodList.push(period);
            }
          }

          // 先按开始时间，再按结束时间，升序排序
          this.teacherPeriodList.sort((a, b) => {
            let aStartTime = a.split("-")[0];
            let aEndTime = a.split("-")[1];
            let bStartTime = b.split("-")[0];
            let bEndTime = b.split("-")[1];
            if (aStartTime < bStartTime) {
              return -1;
            }
            if (aStartTime > bStartTime) {
              return 1;
            }
            return 0;
          });

          // console.log("this.teacherPeriodList:", this.teacherPeriodList);
        } else {
          console.log("调用 getTeacherCourseArrange 出错:", resp1.data.msg);
          alert("调用后端出错: " + resp1.data.msg);
        }
      } catch (error) {
        console.log("catch error:", error);
        alert("catch error " + error);
      } finally {
        loading.close();
      }
    },
    //获取选择的月份的假期
    async queryVacation() {
      //loading界面
      const loading = ElLoading.service({
        lock: true,
        text: "处理中...",
        background: "rgba(0, 0, 0, 0.7)"
      });
      try {
        let teacherIds = [];
        for (let i in this.teacherList) {
          //只获取启用的老师的假期
          if (this.teacherList[i].isActive == 1) {
            teacherIds.push(this.teacherList[i].id);
          }
        }
        let startDate = this.monthDates[0].completeDate;
        let endDate = this.monthDates[this.monthDates.length - 1].completeDate;
        let dateRange = [startDate, endDate];

        // console.log("teacherIds:", teacherIds);
        // console.log("dateRange:", dateRange);

        let params = {
          teacherIds: teacherIds,
          dateRange: dateRange
        };
        let resp1 = await axios.post("https://backend.wonology.com/courseArrange/vacation/queryVacation", params);
        if (resp1.data.code == "0000") {
          this.vacationList = resp1.data.data;

          // console.log("this.vacationList:", this.vacationList);

          loading.close();
        } else {
          console.log("调用后端出错:", resp1.data.msg);
          loading.close();
          alert("调用后端出错: " + resp1.data.msg);
        }
      } catch (error) {
        console.log("catch error:", error);
        loading.close();
        alert("catch error " + error);
      }
    },
    // 获取学生列表
    async getStudentList() {
      //loading界面
      const loading = ElLoading.service({
        lock: true,
        text: "处理中...",
        background: "rgba(0, 0, 0, 0.7)"
      });
      try {
        let params = {
          institution: this.institution
        };
        let resp1 = await axios.post("https://backend.wonology.com/enrollAndClear/studentManagement/getStudentList", params);
        if (resp1.data.code == "0000") {
          this.studentList = resp1.data.data;
          this.studentNames = {};
          for (let i = 0; i < this.studentList.length; i++) {
            this.studentNames[this.studentList[i].id] = this.studentList[i].name;
          }
        } else {
          console.log("调用后端出错:", resp1.data.msg);
          alert("调用后端出错: " + resp1.data.msg);
        }
      } catch (error) {
        console.log("catch error:", error);
        alert("catch error: " + error);
      } finally {
        loading.close();
      }
    },
    // 获取学生的课程安排
    async getStudentCourseArrange() {
      //loading界面
      const loading = ElLoading.service({
        lock: true,
        text: "处理中...",
        background: "rgba(0, 0, 0, 0.7)"
      });
      try {
        let params = {
          studentId: this.studentList[this.selectedStudentIndex].id,
          startDate: this.monthDates[0].completeDate,
          endDate: this.monthDates[this.monthDates.length - 1].completeDate,
          institution: this.institution
        };
        let resp1 = await axios.post("https://backend.wonology.com/courseArrange/courseArrange/getStudentCourseArrange", params);
        if (resp1.data.code == "0000") {
          this.studentCourseArrangeList = resp1.data.data;

          // console.log(
          //   "this.studentCourseArrangeList:",
          //   this.studentCourseArrangeList
          // );
        } else {
          console.log("调用 getStudentCourseArrange 出错:", resp1.data.msg);
          alert("调用后端出错: " + resp1.data.msg);
        }
      } catch (error) {
        console.log("catch error:", error);
        alert("catch error " + error);
      } finally {
        loading.close();
      }
    },
    //列表横纵滚动
    handleScroll(event) {
      const scrollLeft = event.target.scrollLeft;
      const scrollTop = event.target.scrollTop;

      // // 移动固定表头
      // this.$refs.fixedHeader.style.transform = `translateX(-${scrollLeft}px)`;

      // // 移动固定列
      // this.$refs.fixedColumn.style.transform = `translateY(-${scrollTop}px)`;
    },
    // 框选，批量删除 功能
    mouseOverCourseCell(index0, index, index2) {
      // console.log("鼠标进入单元格:", index0, index, index2);

      this.mouseOnCourseCell = true;
    },
    mouseLeaveCourseCell() {
      this.mouseOnCourseCell = false;
    },
    // 鼠标按下，准备框选
    handleMouseDown(e) {
      // 只响应左键点击
      if (e.button !== 0) return;

      // 如果鼠标在课程的单元格中，移动鼠标的效果是拖动课程，不是框选
      if (this.mouseOnCourseCell) {
        return;
      }

      // 如果鼠标在 批量删除排课 按钮上，不触发框选
      if (this.mouseOverDeleteMultipleCourseButtonFlag) {
        return;
      }
      // 正在确认批量删除排课，不触发框选
      if (this.showDeleteMultipleCourseConfirm) {
        return;
      }
      let appElement = document.getElementById("app");
      let appTop = appElement.style.marginTop;
      let appLeft = appElement.style.marginLeft;
      appTop = appTop.split("px")[0];
      appLeft = appLeft.split("px")[0];
      this.isSelecting = true;
      this.startX = e.clientX / this.zoom - appLeft;
      this.startY = e.clientY / this.zoom - appTop;

      // console.log("鼠标按下位置:", this.startX, this.startY);

      // 创建选择框
      this.selectionBox = document.createElement("div");
      this.selectionBox.style.position = "absolute";
      this.selectionBox.style.border = "2px dashed #007bff";
      this.selectionBox.style.backgroundColor = "rgba(0, 123, 255, 0.1)";
      this.selectionBox.style.pointerEvents = "none"; // 不阻挡鼠标事件
      this.div1Element.appendChild(this.selectionBox);
      document.addEventListener("mousemove", this.handleMouseMove);
      document.addEventListener("mouseup", this.handleMouseUp);
    },
    handleMouseMove(e) {
      if (!this.isSelecting) return;
      let appElement = document.getElementById("app");
      let appTop = appElement.style.marginTop;
      let appLeft = appElement.style.marginLeft;
      appTop = appTop.split("px")[0];
      appLeft = appLeft.split("px")[0];
      const currentX = e.clientX / this.zoom - appLeft;
      const currentY = e.clientY / this.zoom - appTop;

      // console.log("鼠标移动位置:", currentX, currentY);

      const left = Math.min(this.startX, currentX);
      const top = Math.min(this.startY, currentY);
      const width = Math.abs(currentX - this.startX);
      const height = Math.abs(currentY - this.startY);

      // console.log("选择框位置:", left, top, width, height);

      this.selectionBox.style.left = `${left}px`;
      this.selectionBox.style.top = `${top}px`;
      this.selectionBox.style.width = `${width}px`;
      this.selectionBox.style.height = `${height}px`;
    },
    handleMouseUp() {
      if (!this.isSelecting) return;
      this.isSelecting = false;
      const selectedDivs = this.getSelectedDivs();
      // console.log("Selected Divs:", selectedDivs); // 输出选中的 div

      // 清除之前的阴影效果
      this.removeShadowFromSelectedDivs();

      // 给选中的div添加阴影效果
      this.selectedElements = selectedDivs.map(divInfo => divInfo.element);
      this.addShadowToSelectedDivs();

      // 清理 div框
      if (this.selectionBox && this.selectionBox.parentNode) {
        this.selectionBox.parentNode.removeChild(this.selectionBox);
      }
      document.removeEventListener("mousemove", this.handleMouseMove);
      document.removeEventListener("mouseup", this.handleMouseUp);
    },
    // 获取框住的所有的课程单元格
    getSelectedDivs() {
      const classCourseTableElement = document.getElementById("classCourseTable");
      // console.log("classCourseTableElement:", classCourseTableElement);
      if (!classCourseTableElement) return [];
      const classCourseTableRect = classCourseTableElement.getBoundingClientRect();

      // console.log("classCourseTableRect.top:", classCourseTableRect.top)
      // console.log("classCourseTableRect.bottom:", classCourseTableRect.bottom)

      const selected = [];
      const boxRect = this.selectionBox.getBoundingClientRect();
      // 获取所有的课程单元格
      const cells = this.div1Element.querySelectorAll(".course-cell");
      cells.forEach(cell => {
        const cellRect = cell.getBoundingClientRect();
        // 检查两个矩形是否有重叠 (是否框住课程单元格)
        if (boxRect.left < cellRect.right && boxRect.right > cellRect.left && boxRect.top < cellRect.bottom && boxRect.bottom > cellRect.top) {
          // 课程要完整在可视范围内
          if (classCourseTableRect.top <= cellRect.top && classCourseTableRect.bottom >= cellRect.bottom) {
            selected.push(cell);
          }
        }
      });

      // 输出选中的 div 元素
      // return selected;

      // 框选的div的index0，index，index2
      const divsWithIndexes = selected.map(div => {
        return {
          element: div,
          index0: parseInt(div.dataset.index0),
          index: parseInt(div.dataset.index),
          index2: parseInt(div.dataset.index2)
        };
      });
      return divsWithIndexes;
    },
    // 框住的div添加阴影的方法
    addShadowToSelectedDivs() {
      this.selectedElements.forEach(async element => {
        if (element) {
          // element.style.boxShadow = "inset 0 0 10px rgba(0, 0, 255, 0.5)";
          // element.style.border = "2px dashed #1b48bb";

          const targetDivs = element.querySelectorAll("div.shadowDiv");
          //  console.log("targetDivs:", targetDivs);

          targetDivs.forEach(div => {
            div.style.display = "block";
          });
        }
      });
    },
    removeShadowFromSelectedDivs() {
      this.selectedElements.forEach(element => {
        if (element) {
          // element.style.boxShadow = "none";
          // element.style.border = "none";

          const targetDivs = element.querySelectorAll("div.shadowDiv");
          targetDivs.forEach(div => {
            div.style.display = "none";
          });
        }
      });
    },
    mouseOverDeleteMultipleCourseButton() {
      this.mouseOverDeleteMultipleCourseButtonFlag = true;
    },
    mouseLeaveDeleteMultipleCourseButton() {
      this.mouseOverDeleteMultipleCourseButtonFlag = false;
    },
    // 批量删除排课
    deleteMultipleCourse() {
      if (this.selectedElements.length === 0) {
        alert("请框选要删除的排课");
        return;
      }
      this.showDeleteMultipleCourseConfirm = true;
    },
    async deleteMultipleCourseConfirm() {
      for (let i = 0; i < this.selectedElements.length; i++) {
        this.deleteCourseArrangeIndexs = [parseInt(this.selectedElements[i].dataset.index0), parseInt(this.selectedElements[i].dataset.index), parseInt(this.selectedElements[i].dataset.index2)];
        await this.confirmDeleteCourseArrange();
      }
      this.showDeleteMultipleCourseConfirm = false;
    },
    deleteMultipleCourseCancel() {
      this.showDeleteMultipleCourseConfirm = false;
    },
    // 班级课表，老师课表切换
    clickWhichCourseTable(type) {
      this.showWhichCourseTable = type;
    },
    // 获取选择的月份有多少天, 是星期几
    getMonthInfo(dateRange) {
      const weekdays = ["周日", "周一", "周二", "周三", "周四", "周五", "周六"];

      // 如果传了日期段, 返回monthDates，不给this变量赋值
      if (Array.isArray(dateRange) && dateRange.length === 2 && dateRange[0] && dateRange[1]) {
        const [startDate, endDate] = dateRange;
        const start = moment(startDate, "YYYY-MM-DD");
        const end = moment(endDate, "YYYY-MM-DD");
        let monthDates = [];
        if (!start.isValid() || !end.isValid()) {
          monthDates = [];
          return monthDates;
        }

        // 计算区间外补齐：从区间起始所在周的周一开始，到区间结束所在周的周日结束
        const startDayOfWeek = start.day(); // 0..6 (周日..周六)
        const offsetToMonday = startDayOfWeek === 0 ? -6 : 1 - startDayOfWeek;
        const paddedStart = start.clone().add(offsetToMonday, "days");
        const endDayOfWeek = end.day(); // 0..6
        const offsetToSunday = endDayOfWeek === 0 ? 0 : 7 - endDayOfWeek;
        const paddedEnd = end.clone().add(offsetToSunday, "days");
        const dates = [];
        for (let d = paddedStart.clone(); d.isSameOrBefore(paddedEnd, "day"); d.add(1, "day")) {
          const completeDate = d.format("YYYY-MM-DD");
          const dayOfWeek = d.day(); // 0..6

          dates.push({
            date: parseInt(completeDate.split("-")[2]),
            // 1..31
            completeDate,
            dayOfWeek,
            dayOfWeekText: weekdays[dayOfWeek],
            ifGrey: d.isBefore(start, "day") || d.isAfter(end, "day") // 区间外灰色
          });
        }
        monthDates = dates;
        return monthDates;
      }

      // 没传日期段：根据 selectedMonth 生成当月，并补齐到完整周（保持你原有月视图逻辑）
      const [year, month] = this.selectedMonth.split("-").map(Number);
      const dates = [];

      // 获取当月最后一天
      const lastDay = new Date(year, month, 0);

      // 生成当月所有日期
      for (let i = 1; i <= lastDay.getDate(); i++) {
        const date = new Date(year, month - 1, i);

        // 第一天如果不是周一，自动补全一周
        if (i == 1) {
          // 一周的第几天，周日是0，周一是1，以此类推
          let day = date.getDay();
          if (date.getDay() == 0) {
            day = 7;
          }
          // 如果第一天不是周一，补全一周
          if (day >= 2) {
            let completeDate = this.selectedMonth + "-" + date.getDate().toString().padStart(2, "0");
            for (let j = day - 1; j >= 1; j--) {
              const previousDay = moment(completeDate).subtract(j, "days").format("YYYY-MM-DD");
              dates.push({
                date: parseInt(previousDay.split("-")[2]),
                completeDate: previousDay,
                dayOfWeek: day - j,
                dayOfWeekText: weekdays[day - j],
                ifGrey: true // 不是这个月的日期，灰色
              });
            }
          }
        }
        dates.push({
          date: date.getDate(),
          completeDate: this.selectedMonth + "-" + date.getDate().toString().padStart(2, "0"),
          dayOfWeek: date.getDay(),
          dayOfWeekText: weekdays[date.getDay()]
        });

        // 最后一天，如果不是周日，补齐到周日
        if (i == lastDay.getDate()) {
          if (date.getDay() != 0) {
            let day = date.getDay();
            let completeDate = this.selectedMonth + "-" + date.getDate().toString().padStart(2, "0");
            for (let j = 1; j <= 7 - day; j++) {
              const nextDay = moment(completeDate).add(j, "days").format("YYYY-MM-DD");
              dates.push({
                date: parseInt(nextDay.split("-")[2]),
                completeDate: nextDay,
                dayOfWeek: (day + j) % 7,
                dayOfWeekText: weekdays[(day + j) % 7],
                ifGrey: true
              });
            }
          }
        }
      }
      this.monthDates = dates;
    },
    // 选择月份
    async handleMonthChange(value) {
      // 重置选择的日期索引。如果有31天，index 30, 切换到没有31天的月份，会超出数组长度
      this.teacherCourseSelectedDateIndex = 0;
      let currentMonth = this.todayDate.split("-")[0] + "-" + this.todayDate.split("-")[1];

      //选择的不是当月，滚动条清零，从第一天开始展示
      if (value != currentMonth) {
        const scrollContainer = document.getElementById("scrollArea");
        if (scrollContainer) {
          scrollContainer.scrollTop = 0;
        }
      }
      //选择的是当月
      else {
        //滚动条自动把这周放最上面
        let todayIndex = 0;
        for (let i = 0; i < this.monthDates.length; i++) {
          if (this.monthDates[i].completeDate === this.todayDate) {
            todayIndex = i;
          }
        }
        const scrollTop = Math.floor(todayIndex / 7) * (100 + this.classList[this.selectedClassIndex].periods.length * 80);
        const scrollContainer = document.getElementById("scrollArea");
        if (scrollContainer) {
          scrollContainer.scrollTop = scrollTop;
        }
      }

      // console.log("选择的月份:", value);
      this.selectedMonth = value;

      //获取这个月有多少天
      this.getMonthInfo();

      // console.log("this.classList.length:", this.classList.length)
      //获取这个月课程安排
      if (this.classList.length > 0) {
        await this.getClassCourseArrange();
      }
      // console.log("this.teacherList.length:", this.teacherList.length)
      if (this.teacherList.length > 0) {
        await this.getTeacherCourseArrange();
      }
      // console.log("this.studentList.length:", this.studentList.length)
      if (this.studentList.length > 0) {
        await this.getStudentCourseArrange();
      }
      //获取这个月休假安排
      await this.queryVacation();

      //切换月份，复制重置
      // this.dragStartIndexs = [];
    },
    // 选择班级
    async chooseClass() {
      this.showChooseClass = true;
      this.searchStr = "";

      // 获取班级列表，已排课时
      await this.getClassList();
    },
    async confirmChooseClass() {
      this.showChooseClass = false;

      // 获取班级的课程安排
      {
        const t0 = Date.now();
        await this.getClassCourseArrange();
        const dtChooseClass = Date.now() - t0;
        if (dtChooseClass > SLOW_STEP_LOG_MS) {
          console.log(`获取班级课程用时： ${dtChooseClass}ms (>${SLOW_STEP_LOG_MS}ms)`);
        }
      }
      //切换班级后，复制重置
      this.dragStartIndexs = [];
      this.dragStartDate = "";
      this.dragStartCourseObject = {};
    },
    cancelChooseClass() {
      this.showChooseClass = false;
    },
    //点击班级名，也可选择班级
    clickClassName(index) {
      this.selectedClassIndex = index;
    },
    //简洁视图 按钮
    conciseClassArrange() {
      if (this.selectConciseClassArrange && this.showWhichCourseTable == "class") {
        // 每周
        for (let j = 0; j < this.monthDates.length / 7; j++) {
          this.weekPeriodShow[j] = {};

          // 每个时间段
          for (let i in this.classList[this.selectedClassIndex].periods) {
            let period = this.classList[this.selectedClassIndex].periods[i];
            let flag = false;

            // 一周的每天
            for (let k = 0; k < 7; k++) {
              let date = this.monthDates[j * 7 + k].completeDate;
              // 如果这周这个时间段 至少一天有课，这个时间段就不隐藏
              if (this.courseArrangeList[date]) {
                if (this.courseArrangeList[date][period]) {
                  flag = true;
                  break;
                }
              }
            }
            if (flag == false) {
              this.weekPeriodShow[j][period] = false;
            } else {
              this.weekPeriodShow[j][period] = true;
            }
          }
        }
        console.log("this.weekPeriodShow:", this.weekPeriodShow);
      }
      if (this.selectConciseClassArrange && this.showWhichCourseTable == "teacher") {
        // 每周
        for (let j = 0; j < this.monthDates.length / 7; j++) {
          this.weekPeriodShow[j] = {};

          // 每个时间段
          for (let i in this.teacherPeriodList) {
            let period = this.teacherPeriodList[i];
            let flag = false;

            // 一周的每天
            for (let k = 0; k < 7; k++) {
              let date = this.monthDates[j * 7 + k].completeDate;
              // 如果这周这个时间段 至少一天有课，这个时间段就不隐藏
              if (this.teacherCourseArrangeList[date]) {
                if (this.teacherCourseArrangeList[date][period]) {
                  flag = true;
                  break;
                }
              }
            }
            if (flag == false) {
              this.weekPeriodShow[j][period] = false;
            } else {
              this.weekPeriodShow[j][period] = true;
            }
          }
        }
        console.log("this.weekPeriodShow:", this.weekPeriodShow);
      }
    },
    //简洁视图 文字
    conciseClassArrangeWord() {
      this.selectConciseClassArrange = !this.selectConciseClassArrange;
      this.conciseClassArrange();
    },
    // 拖拽开始事件
    handleDragStart(event, index0, index, index2) {
      console.log("handleDragStart index0, index, index2:", index0, index, index2);

      // 如果这个单元格没有课程，不能复制，直接返回
      if (this.courseArrangeList[this.monthDates[index0 * 7 + index2].completeDate] && this.courseArrangeList[this.monthDates[index0 * 7 + index2].completeDate][this.classList[this.selectedClassIndex].periods[index]]) {} else {
        // this.dragStartIndexs = [];

        return;
      }
      this.dragStartIndexs = [index0, index, index2];
      this.dragStartDate = this.monthDates[index0 * 7 + index2].completeDate;
      this.dragStartCourseObject = {
        teacherId: this.courseArrangeList[this.monthDates[index0 * 7 + index2].completeDate][this.classList[this.selectedClassIndex].periods[index]].teacherId,
        classroomId: this.courseArrangeList[this.monthDates[index0 * 7 + index2].completeDate][this.classList[this.selectedClassIndex].periods[index]].classroomId,
        course: this.courseArrangeList[this.monthDates[index0 * 7 + index2].completeDate][this.classList[this.selectedClassIndex].periods[index]].course,
        period: this.classList[this.selectedClassIndex].periods[index],
        date: this.monthDates[index0 * 7 + index2].completeDate
      };
    },
    // 拖拽放置
    async handleDrop(event, index0, index, index2) {
      console.log("handleDrop index0, index, index2:", index0, index, index2);
      if (this.dragStartIndexs.length == 0) {
        return;
      }
      await this.handleDragOrCopy("move", index0, index, index2);

      // 移动后，重置拖拽起始日期
      this.dragStartIndexs = [];
      this.dragStartDate = "";
      this.dragStartCourseObject = {};
    },
    // 复制课程
    handleCopy(event, index0, index, index2) {
      console.log("handleCopy index0, index, index2:", index0, index, index2);

      // 如果这个单元格没有课程，不能复制，直接返回
      if (this.courseArrangeList[this.monthDates[index0 * 7 + index2].completeDate] && this.courseArrangeList[this.monthDates[index0 * 7 + index2].completeDate][this.classList[this.selectedClassIndex].periods[index]]) {} else {
        return;
      }
      this.dragStartIndexs = [index0, index, index2];
      this.dragStartDate = this.monthDates[index0 * 7 + index2].completeDate;
      this.dragStartCourseObject = {
        teacherId: this.courseArrangeList[this.monthDates[index0 * 7 + index2].completeDate][this.classList[this.selectedClassIndex].periods[index]].teacherId,
        classroomId: this.courseArrangeList[this.monthDates[index0 * 7 + index2].completeDate][this.classList[this.selectedClassIndex].periods[index]].classroomId,
        course: this.courseArrangeList[this.monthDates[index0 * 7 + index2].completeDate][this.classList[this.selectedClassIndex].periods[index]].course,
        period: this.classList[this.selectedClassIndex].periods[index],
        date: this.monthDates[index0 * 7 + index2].completeDate
      };
    },
    // 粘贴课程
    async handlePaste(event, index0, index, index2) {
      console.log("handlePaste index0, index, index2:", index0, index, index2);
      if (this.dragStartIndexs.length == 0) {
        return;
      }
      await this.handleDragOrCopy("", index0, index, index2);
    },
    // 处理拖拽或粘贴
    async handleDragOrCopy(flag, index0, index, index2) {
      //如果还是原位置，返回
      if (this.dragStartDate == this.monthDates[index0 * 7 + index2].completeDate && index == this.dragStartIndexs[1]) {
        return;
      }

      // 这个日期有内容 && 这个时间段有 内容
      if (this.courseArrangeList[this.monthDates[index0 * 7 + index2].completeDate] && this.courseArrangeList[this.monthDates[index0 * 7 + index2].completeDate][this.classList[this.selectedClassIndex].periods[index]]) {
        alert("该时间段已排课");
        return;
      }

      //如果两个时间段长度不一样
      let formerDuration = this.calculateTimeDuration(this.classList[this.selectedClassIndex].periods[this.dragStartIndexs[1]]);
      let latterDuration = this.calculateTimeDuration(this.classList[this.selectedClassIndex].periods[index]);
      if (formerDuration.totalMinutes !== latterDuration.totalMinutes) {
        //显示询问是否要修改时间段的提示弹窗
        this.showTimeisDifferent = true;
        this.timeisDifferentWord = `课程原时间段${this.classList[this.selectedClassIndex].periods[this.dragStartIndexs[1]]}，时长为${formerDuration.formatted}，与要移到的时间段${this.classList[this.selectedClassIndex].periods[index]}时长为${latterDuration.formatted}不一致。`;
        return;
      }

      //判断新时间段，老师是否有冲突
      let teacherIdList = [];
      for (let i = 0; i < this.teacherList.length; i++) {
        // 只能选该班级中的老师
        if (this.classList[this.selectedClassIndex].teacherIds.includes(this.teacherList[i].id)) {
          teacherIdList.push(this.teacherList[i].id);
        }
      }
      let params = {
        teacherIdList: teacherIdList,
        selectedDate: this.monthDates[index0 * 7 + index2].completeDate,
        selectedPeriod: this.classList[this.selectedClassIndex].periods[index]
      };
      let resp1 = await axios.post("https://backend.wonology.com/courseArrange/courseArrange/queryTeacherIfFree", params);
      if (resp1.data.code == "0000") {
        this.teacherIdListAvailable = resp1.data.data;
        console.log("this.teacherIdListAvailable:", this.teacherIdListAvailable);

        // 如果老师在新时间段没空
        if (this.teacherIdListAvailable[this.dragStartCourseObject.teacherId] != 1) {
          alert("授课老师这个时间段没空");
          return;

          // 如果没空，弹出修改老师弹窗
          await this.dealChangeTeacher();
        }
      } else {
        console.log("调用后端出错:", resp1.data.msg);
        alert("调用后端出错: " + resp1.data.msg);
        return;
      }

      //判断新时间段，教室是否有冲突
      //获取有空的教室
      //找出对应的index
      const campusIndex = this.campusList.findIndex(item => item.campus.id == this.classList[this.selectedClassIndex].campusId);
      let classroomIdList = [];
      for (let i = 0; i < this.campusList[campusIndex].classrooms.length; i++) {
        classroomIdList.push(this.campusList[campusIndex].classrooms[i].id);
      }
      params = {
        classroomIdList: classroomIdList,
        selectedDate: this.monthDates[index0 * 7 + index2].completeDate,
        selectedPeriod: this.classList[this.selectedClassIndex].periods[index]
      };
      resp1 = await axios.post("https://backend.wonology.com/courseArrange/courseArrange/queryClassroomIfFree", params);
      if (resp1.data.code == "0000") {
        this.classroomIfAvailable = resp1.data.data;

        // console.log("this.classroomIfAvailable:", this.classroomIfAvailable);

        // 清空 selectedClassroomId, 如果教室有冲突，会赋值
        this.selectedClassroomId = "";

        // 如果教室有冲突, 换教室弹窗
        if (this.classroomIfAvailable[this.dragStartCourseObject.classroomId] != 1) {
          this.selectedDate = this.monthDates[index0 * 7 + index2].completeDate;
          this.selectedPeriod = this.classList[this.selectedClassIndex].periods[index];
          this.selectedClassroomId = "";

          // 新时间段教室有冲突，换教室 弹窗
          // 这里选择selectedClassroomId
          await this.dealChangeClassroom();

          //如果没有修改教室，直接返回
          if (!this.ifChangeClassroom) {
            return;
          }

          // 待仔细分析，这里是不是可以不要
          // this.courseArrangeList[
          //   this.monthDates[index0 * 7 + index2].completeDate
          // ][
          //   this.classList[this.selectedClassIndex].periods[
          //     this.dragStartIndexs[1]
          //   ]
          // ].classroomId = this.selectedClassroomId;
        }
      } else {
        console.log("调用queryClassroomIfFree出错:", resp1.data.msg);
        alert("调用后端出错: " + resp1.data.msg);
        return;
      }

      // 等于调用添加课程安排（判断新时间段是否和其他课程有时间冲突）
      this.selectQuickArrangeCourse = false;
      // this.addCourseArrangeFlag = "move";
      this.addCourseArrangeFlag = flag;
      this.selectedDate = this.monthDates[index0 * 7 + index2].completeDate;
      this.selectedPeriod = this.classList[this.selectedClassIndex].periods[index];
      this.selectedTeacherId = this.dragStartCourseObject.teacherId;
      // 如果 selectedClassroomId 为空，表示教室没冲突，用之前的教室
      if (this.selectedClassroomId == "") {
        this.selectedClassroomId = this.dragStartCourseObject.classroomId;
      }
      // 如果 selectedClassroomId 不为空，表示教室有冲突，用新的教室，同一个变量，不用赋值
      else {
        // this.selectedClassroomId = this.selectedClassroomId;
      }
      this.selectedCourse = this.dragStartCourseObject.course;

      //调用添加课程安排函数
      await this.confirmCourseArrangeStep1();
      this.addCourseArrangeFlag = "";
    },
    // 计算hh:mm-hh:mm 时间段长度的方法
    calculateTimeDuration(timeRange) {
      // timeRange 格式: "09:00-10:30"
      const [startTime, endTime] = timeRange.split("-");

      // 将时间字符串转换为分钟数
      const parseTimeToMinutes = timeStr => {
        const [hours, minutes] = timeStr.split(":").map(Number);
        return hours * 60 + minutes;
      };
      const startMinutes = parseTimeToMinutes(startTime);
      const endMinutes = parseTimeToMinutes(endTime);

      // 计算时间差（分钟）
      const durationMinutes = endMinutes - startMinutes;

      // 转换为小时和分钟
      const hours = Math.floor(durationMinutes / 60);
      const minutes = durationMinutes % 60;
      return {
        totalMinutes: durationMinutes,
        hours: hours,
        minutes: minutes,
        formatted: `${hours}小时${minutes}分钟`
      };
    },
    // 时间段长度不一致提示弹窗 关闭
    cancelDifferentTimeTooltip() {
      this.showTimeisDifferent = false;
    },
    // 新时间段老师有冲突，换老师
    dealChangeTeacher() {
      this.showChangeTeacher = true;
    },
    // 新时间段教室有冲突，换教室
    async dealChangeClassroom() {
      this.showChangeClassroom = true;

      // 等待用户操作完成
      await new Promise(resolve => {
        // 保存 resolve 方法，以便在 confirmChangeClassroom 中调用
        //直到resolveChangeClassroom 为 null，才会退出这个 await new Promise
        this.resolveChangeClassroom = resolve;
      });
    },
    confirmChangeClassroom() {
      // 隐藏弹窗
      this.showChangeClassroom = false;
      this.ifChangeClassroom = true;

      // 调用 resolve 方法，让 dealChangeClassroom 继续执行
      if (this.resolveChangeClassroom) {
        this.resolveChangeClassroom();
        this.resolveChangeClassroom = null; // 清除引用
      }
    },
    cancelChangeClassroom() {
      this.showChangeClassroom = false;
      this.ifChangeClassroom = false;

      // 如果用户取消，也需 resolve Promise 以继续执行
      if (this.resolveChangeClassroom) {
        this.resolveChangeClassroom();
        this.resolveChangeClassroom = null; // 清除引用
      }
    },
    showDeleteCourseArrangeButton(index0, index, index2) {
      // console.log("showDeleteCourseArrangeButton:", index0, index, index2);

      this.showDeleteCourseArrangeButtonIndexStr = `${index0},${index},${index2}`;
    },
    hiddenDeleteCourseArrangeButton() {
      // console.log("hiddenDeleteCourseArrangeButton");

      this.showDeleteCourseArrangeButtonIndexStr = "";
    },
    // 删除排课
    deleteCourseArrange(index0, index, index2) {
      this.deleteCourseArrangeIndexs = [index0, index, index2];
      this.showDeleteCourseArrange = true;
    },
    async confirmDeleteCourseArrange() {
      //loading界面
      const loading = ElLoading.service({
        lock: true,
        text: "处理中...",
        background: "rgba(0, 0, 0, 0.7)"
      });
      try {
        let [index0, index, index2] = this.deleteCourseArrangeIndexs;
        let params = {
          username: this.username,
          institution: this.institution,
          classId: this.classList[this.selectedClassIndex].id,
          selectedDate: this.monthDates[index0 * 7 + index2].completeDate,
          selectedPeriod: this.classList[this.selectedClassIndex].periods[index]
        };
        let resp1 = await axios.post("https://backend.wonology.com/courseArrange/courseArrange/deleteCourseArrange", params);
        if (resp1.data.code == "0000") {
          this.showDeleteCourseArrange = false;

          // 重新获取排课
          await this.getClassCourseArrange();
          await this.getTeacherCourseArrange();
          if (this.studentList.length > 0) {
            await this.getStudentCourseArrange();
          }
          let classId = this.classList[this.selectedClassIndex].id;
          // 更新班级已排课时
          await this.getClassList();
          // 根据classId找index
          this.selectedClassIndex = this.classList.findIndex(classObj => classObj.id === classId);
        } else {
          console.log("调用后端出错:", resp1.data.msg);
          alert("调用后端出错: " + resp1.data.msg);
        }
      } catch (error) {
        console.log("catch error: " + error);
        alert("catch error " + error);
      } finally {
        loading.close();
      }
    },
    cancelDeleteCourseArrange() {
      this.showDeleteCourseArrange = false;
    },
    /////
    // 具体排课
    //双击单元格 进行排课
    async doubleClickUnit(index0, index, index2) {
      //loading界面
      const loading = ElLoading.service({
        lock: true,
        text: "处理中...",
        background: "rgba(0, 0, 0, 0.7)"
      });
      try {
        console.log("双击单元格:", index0, index, index2);
        let dateIndex = index0 * 7 + index2;
        this.selectedDate = this.monthDates[dateIndex].completeDate;
        this.selectedWeekday = this.monthDates[dateIndex].dayOfWeekText;
        this.selectedPeriod = this.classList[this.selectedClassIndex].periods[index];

        //获取老师是否有空
        let teacherIdList = [];
        for (let i = 0; i < this.teacherList.length; i++) {
          // 只能选该班级中的老师
          if (this.classList[this.selectedClassIndex].teacherIds.includes(this.teacherList[i].id)) {
            teacherIdList.push(this.teacherList[i].id);
          }
        }
        let params = {
          teacherIdList: teacherIdList,
          selectedDate: this.selectedDate,
          selectedPeriod: this.selectedPeriod
        };
        const tTeacherIfFree0 = Date.now();
        let resp1 = await axios.post("https://backend.wonology.com/courseArrange/courseArrange/queryTeacherIfFree", params);
        const dtTeacherIfFree = Date.now() - tTeacherIfFree0;
        if (dtTeacherIfFree > SLOW_STEP_LOG_MS) {
          console.log(`[doubleClickUnit] queryTeacherIfFree took ${dtTeacherIfFree}ms (>${SLOW_STEP_LOG_MS}ms)`);
        }
        if (resp1.data.code == "0000") {
          this.teacherIdListAvailable = resp1.data.data;
          console.log("this.teacherIdListAvailable:", this.teacherIdListAvailable);
        } else {
          console.log("调用后端queryTeacherIfFree出错:", resp1.data.msg);
          alert("调用后端出错: " + resp1.data.msg);
        }

        //获取有空的教室
        //找出班级对应的校区index
        const campusIndex = this.campusList.findIndex(item => item.campus.id == this.classList[this.selectedClassIndex].campusId);
        //获取教室id列表
        let classroomIdList = [];
        for (let i = 0; i < this.campusList[campusIndex].classrooms.length; i++) {
          classroomIdList.push(this.campusList[campusIndex].classrooms[i].id);
        }
        params = {
          classroomIdList: classroomIdList,
          selectedDate: this.selectedDate,
          selectedPeriod: this.selectedPeriod
        };
        const tClassroomIfFree0 = Date.now();
        resp1 = await axios.post("https://backend.wonology.com/courseArrange/courseArrange/queryClassroomIfFree", params);
        const dtClassroomIfFree = Date.now() - tClassroomIfFree0;
        if (dtClassroomIfFree > SLOW_STEP_LOG_MS) {
          console.log(`[doubleClickUnit] queryClassroomIfFree took ${dtClassroomIfFree}ms (>${SLOW_STEP_LOG_MS}ms)`);
        }
        if (resp1.data.code == "0000") {
          this.classroomIfAvailable = resp1.data.data;
          console.log("this.classroomIfAvailable:", this.classroomIfAvailable);
        } else {
          console.log("调用queryClassroomIfFree出错:", resp1.data.msg);
          alert("调用后端出错: " + resp1.data.msg);
        }

        // 如果点击的日期，时间段，已经安排课程，
        // 那就是要修改排课，输入框中赋值
        if (this.courseArrangeList[this.monthDates[dateIndex].completeDate] && this.courseArrangeList[this.monthDates[dateIndex].completeDate][this.classList[this.selectedClassIndex].periods[index]]) {
          this.selectedTeacherId = this.courseArrangeList[this.monthDates[dateIndex].completeDate][this.classList[this.selectedClassIndex].periods[index]].teacherId;

          // 模拟选择老师，获取老师的courseList（不然courseList为空）
          this.selectTeacher();
          this.selectedCourse = this.courseArrangeList[this.monthDates[dateIndex].completeDate][this.classList[this.selectedClassIndex].periods[index]].course;
          this.selectedClassroomId = this.courseArrangeList[this.monthDates[dateIndex].completeDate][this.classList[this.selectedClassIndex].periods[index]].classroomId;
        }
        // 如果这个时间段没排课
        //重置变量
        else {
          this.selectedTeacherId = "";
          this.selectedCourse = "";
          this.selectedClassroomId = "";
        }
      } catch (error) {
        console.log("catch error:", error);
        alert("catch error " + error);
      } finally {
        loading.close();
      }
      this.showCourseArrangeStep1 = true;
    },
    // 点击确认 确认排课 或 跳转到快速排课页面
    async confirmCourseArrangeStep1() {
      // 选择快速排课
      if (this.selectQuickArrangeCourse) {
        //loading界面
        const loading = ElLoading.service({
          lock: true,
          text: "处理中...",
          background: "rgba(0, 0, 0, 0.7)"
        });
        try {
          //判断有没有选择日期时间段
          if (this.quickArrangeDateRange.length != 2) {
            alert(`没有选择快速排课的日期范围`);
            return;
          }

          //判断勾选的周几，有没有选择时间段
          for (let i in this.selectedWeekdays) {
            if (this.selectedWeekdays[i] == true) {
              if (this.selectedWeekdayPeriods[i].length == 0) {
                alert(`${this.weekdays[i]}没有选择时间段`);
                return;
              }
            }
          }

          //找出班级对应的校区index
          const campusIndex = this.campusList.findIndex(item => item.campus.id == this.classList[this.selectedClassIndex].campusId);
          //获取教室id列表
          let classroomIdList = [];
          for (let i = 0; i < this.campusList[campusIndex].classrooms.length; i++) {
            classroomIdList.push(this.campusList[campusIndex].classrooms[i].id);
          }
          //查询一个日期时间段的每个日期，每个时间段，每个老师，是否可以排课
          let params = {
            classId: this.classList[this.selectedClassIndex].id,
            quickArrangeDateRange: this.quickArrangeDateRange,
            selectedWeekdayPeriods: this.selectedWeekdayPeriods,
            classroomIdList: classroomIdList,
            teacherIdList: this.classList[this.selectedClassIndex].teacherIds
          };
          let resp1 = await axios.post("https://backend.wonology.com/courseArrange/courseArrange/queryDatePeriodIfAvailable", params);
          if (resp1.data.code == "0000") {
            /* 数据结构示例
            每个日期，每个时间段，每个老师，是否可排课
            {
              2025-09-15: {
                09:30-11:30: {
                  5: 1,
                  6: 0
                }
              },
              2025-09-16: {}
            }
            */
            this.datePeriodTeacherIfAvailable = resp1.data.data.datePeriodTeacherIfAvailable;

            /* 数据结构示例 
            七个元素，周一到周日，每天对应的时间段，每个老师，可排课数
            [
              {
                09:30-11:30: {
                  5：7，
                  6：6
                },
                10:30-12:30: {
                  5：7，
                  6：6
                }
              },
              {
              }
            ]
            */
            this.weekdayPeriodTeacherAvailableNum = resp1.data.data.weekdayPeriodTeacherAvailableNum;
            this.datePeriodIfAvailable = resp1.data.data.datePeriodIfAvailable;
            this.datePeriodArrangement = JSON.parse(JSON.stringify(this.datePeriodIfAvailable));
            this.oriDatePeriodArrangement = JSON.parse(JSON.stringify(this.datePeriodIfAvailable));
            this.teacherDatePeriodIfAvailable = resp1.data.data.teacherDatePeriodIfAvailable;
            this.oriTeacherDatePeriodIfAvailable = JSON.parse(JSON.stringify(this.teacherDatePeriodIfAvailable));

            // console.log(
            //   "this.datePeriodTeacherIfAvailable:",
            //   this.datePeriodTeacherIfAvailable
            // );

            // console.log(
            //   "this.weekdayPeriodTeacherAvailableNum:",
            //   this.weekdayPeriodTeacherAvailableNum
            // );

            /* 数据结构示例 
            七个元素，周一到周日，每天对应的时间段，每个老师，是否选中
            [
              {
                09:30-11:30: {
                  5：false，
                  6：false
                },
                10:30-12:30: {
                  5：false，
                  6：false
                }
              },
              {
                
              }
            ]
            */
            // 如果需要深拷贝，可以这样修改
            this.weekdayPeriodTeacherIfSelected = JSON.parse(JSON.stringify(this.weekdayPeriodTeacherAvailableNum));

            /* 数据结构示例 
            七个元素，周一到周日，每天对应的时间段，每个老师，是否可选择
            [
              {
                09:30-11:30: {
                  5：false，
                  6：false
                },
                10:30-12:30: {
                  5：false，
                  6：false
                }
              },
              {
                
              }
            ]
            */
            this.ifCanSelectWeekdayPeriodTeacher = JSON.parse(JSON.stringify(this.weekdayPeriodTeacherAvailableNum));

            // 初始化每个老师的可排课数为0
            for (let teacherId of this.classList[this.selectedClassIndex].teacherIds) {
              //初始化为0
              this.teacherAvailableNum[teacherId] = 0;
            }
          } else {
            console.log("调用后端出错:", resp1.data.msg);
            alert("调用后端出错: " + resp1.data.msg);
          }

          // 显示快速排课页面
          // 时间段正序排序
          for (let i in this.selectedWeekdayPeriods) {
            this.selectedWeekdayPeriods[i].sort(); // 字符串默认就是正序排序
          }
          this.teacherCourseArrangeNum = {};
          this.showCourseArrangeStep2 = true;
        } catch (err) {
          console.log("catch error:", err);
          alert("catch error " + err);
        } finally {
          loading.close();
        }
      }
      // 没选快速排课
      else {
        let repriceCourse = false;
        if (this.addCourseArrangeFlag == "move" && this.dragStartDate != this.selectedDate) {
          const priceCheckResp = await axios.post("https://backend.wonology.com/courseArrange/teacherFee/checkCourseReprice", {
            classId: this.classList[this.selectedClassIndex].id,
            oldDate: this.dragStartDate,
            oldPeriod: this.classList[this.selectedClassIndex].periods[this.dragStartIndexs[1]],
            newDate: this.selectedDate
          });
          if (priceCheckResp.data.code != "0000") {
            alert(priceCheckResp.data.msg);
            return;
          }
          if (priceCheckResp.data.data.needConfirm) {
            repriceCourse = window.confirm(`这个课从${this.dragStartDate}移到${this.selectedDate}，` + `课程标准单价由${priceCheckResp.data.data.formerFee}元变为` + `${priceCheckResp.data.data.nextFee}元。\n` + (priceCheckResp.data.data.studentFeeItems.length ? `当前已有学生实际单价：${[...new Set(priceCheckResp.data.data.studentFeeItems.map(item => item.actualFee))].join("、")}元。\n` : "") + `点击“确定”使用当前日期标准单价；` + `点击“取消”保持每个学生之前的实际单价并继续移动课程。`);
          }
        }

        // 判断日期是否超过班级结班日期
        if (this.selectedDate > this.classList[this.selectedClassIndex].endDate) {
          this.showTip = true;
          this.tipMessage = `当前日期已超过班级结班日期，是否继续排课？结班日期会自动改为当前日期。`;

          // 注册resolve函数 （和回调还是有点区别，不过这个方法更好）
          // 后面通过 this.tipResolver(value) 返回值
          const tipConfirmed = await new Promise(resolve => {
            this.tipResolver = resolve;
          });
          if (tipConfirmed === "confirm") {
            // 用户选择确认，继续执行
          } else {
            // 用户选择取消，返回

            return;
          }
        }

        // 判断日期是否早于班级开班日期
        if (this.selectedDate < this.classList[this.selectedClassIndex].startDate) {
          this.showTip = true;
          this.tipMessage = `当前日期早于班级开班日期，是否继续排课？开班日期会自动改为当前日期。`;

          // 注册resolve函数 （和回调还是有点区别，不过这个方法更好）
          // 后面通过 this.tipResolver(value) 返回值
          const tipConfirmed = await new Promise(resolve => {
            this.tipResolver = resolve;
          });
          if (tipConfirmed === "confirm") {
            // 用户选择确认，继续执行
          } else {
            // 用户选择取消，返回

            return;
          }
        }

        // 如果不是move，判断是否超过班级已排课时
        if (this.addCourseArrangeFlag != "move") {
          let courseMinutes = this.calculateTimeDuration(this.selectedPeriod).totalMinutes;
          let arrangedHour = this.classList[this.selectedClassIndex].arrangedHour;
          if (arrangedHour + parseFloat((courseMinutes / 60).toFixed(2)) > this.classList[this.selectedClassIndex].totalHour) {
            this.showTip = true;
            this.tipMessage = `排课课时超过班级设置的总课时，是否继续？`;

            // 注册resolve函数 （和回调还是有点区别，不过这个方法更好）
            // 后面通过 this.tipResolver(value) 返回值
            const tipConfirmed = await new Promise(resolve => {
              this.tipResolver = resolve;
            });
            if (tipConfirmed === "confirm") {
              // 用户选择确认，继续执行

              this.showTip = false;
              // 重置变量
              this.tipMessage = "";
              this.tipNeedInput = false;
            } else {
              // 用户选择取消，返回

              return;
            }
          }
        }

        //loading界面
        const loading = ElLoading.service({
          lock: true,
          text: "处理中...",
          background: "rgba(0, 0, 0, 0.7)"
        });
        try {
          if (!(this.selectedTeacherId && this.selectedClassroomId && this.selectedCourse)) {
            alert("请选择老师，教室，科目");
            return;
          }
          let params = {
            username: this.username,
            institution: this.institution,
            addCourseArrangeFlag: this.addCourseArrangeFlag,
            classId: this.classList[this.selectedClassIndex].id,
            selectedDate: this.selectedDate,
            selectedPeriod: this.selectedPeriod,
            selectedTeacherId: this.selectedTeacherId,
            selectedClassroomId: this.selectedClassroomId,
            selectedCourse: this.selectedCourse,
            repriceCourse: repriceCourse
          };
          if (this.addCourseArrangeFlag == "move") {
            params.dragStartDate = this.dragStartDate;
            params.dragStartPeriod = this.classList[this.selectedClassIndex].periods[this.dragStartIndexs[1]];
          }
          let resp1 = await axios.post("https://backend.wonology.com/courseArrange/courseArrange/addCourseArrange", params);
          if (resp1.data.code == "0000") {
            this.showCourseArrangeStep1 = false;

            // 更新班级, 老师，学生的课程安排
            await Promise.all([this.getClassCourseArrange(), this.getTeacherCourseArrange(), async () => {
              if (this.studentList.length > 0) {
                await this.getStudentCourseArrange();
              }
            }]);

            // 之前的 selectedClassIndex可能是搜索后的classList对应的index，需要找到原来的index
            let classId = this.classList[this.selectedClassIndex].id;

            // 更新班级已排课时, 这里会把classList变为原始的classList
            await this.getClassList();

            // 根据classId找到原来的index
            this.selectedClassIndex = this.classList.findIndex(classObj => classObj.id === classId);
          } else {
            console.log("调用addCourseArrange出错:", resp1.data.msg);
            alert("调用后端出错: " + resp1.data.msg);
          }
        } catch (error) {
          console.log("catch error:", error);
          alert("catch error " + error);
        } finally {
          loading.close();
        }
      }
    },
    // 取消排课页面
    async cancelCourseArrange() {
      //重置变量
      //关闭快速排课相关组件
      this.selectQuickArrangeCourse = false;

      // 取消全选周一到周日
      this.selectedAllWeekdays = false;
      // 选择的周几也都取消
      this.selectedWeekdays = [];
      //时间段都取消
      this.selectedAllPeriod = [false, false, false, false, false, false, false];
      this.selectedWeekdayPeriods = [[], [], [], [], [], [], []];

      // 等el-select下拉框收起，再关闭页面
      await this.$nextTick();

      //关闭排课页面
      this.showCourseArrangeStep1 = false;
    },
    selectTeacher() {
      // console.log("选择老师:", this.selectedTeacherId);

      //找出对应teacher的index
      const index = this.teacherList.findIndex(item => item.id == this.selectedTeacherId);

      //找出这个老师，在这个班级 教授的科目
      this.teacherClassCourseList = [];
      for (let i in this.teacherList[index].courses) {
        if (this.classList[this.selectedClassIndex].courses && this.classList[this.selectedClassIndex].courses.length > 0 && this.classList[this.selectedClassIndex].courses.includes(this.teacherList[index].courses[i])) {
          this.teacherClassCourseList.push(this.teacherList[index].courses[i]);
        }
      }
    },
    selectClassroom() {
      // console.log("this.selectedClassroomId:", this.selectedClassroomId);
      // console.log("this.classroomNames:", this.classroomNames);
    },
    //点击快速排课按钮
    selectQuickArrange() {
      console.log("this.selectQuickArrangeCourse:", this.selectQuickArrangeCourse);
      if (this.selectQuickArrangeCourse) {
        //预设快速排课日期段
        if (this.todayDate < this.classList[this.selectedClassIndex].startDate) {
          this.quickArrangeDateRange = [this.classList[this.selectedClassIndex].startDate, this.classList[this.selectedClassIndex].endDate];
        }
        if (this.todayDate >= this.classList[this.selectedClassIndex].startDate && this.todayDate <= this.classList[this.selectedClassIndex].endDate) {
          this.quickArrangeDateRange = [this.todayDate, this.classList[this.selectedClassIndex].endDate];
        }

        //如果今天已经超过了课程截止时间，自己选时间段
        if (this.todayDate > this.classList[this.selectedClassIndex].endDate) {
          this.quickArrangeDateRange = [];
        }
        console.log("this.quickArrangeDateRange:", this.quickArrangeDateRange);
      }
    },
    // 点击快速排课按钮 文字，也相当于点击按钮
    clickQuickArrangeWord() {
      this.selectQuickArrangeCourse = !this.selectQuickArrangeCourse;
      this.selectQuickArrange();
    },
    //点击全选周一到周日
    selectAllWeekdays() {
      console.log("this.selectedAllWeekdays:", this.selectedAllWeekdays);
      if (this.selectedAllWeekdays) {
        for (let i = 0; i < 7; i++) {
          this.selectedWeekdays[i] = true;
        }
      } else {
        for (let i = 0; i < 7; i++) {
          this.selectedWeekdays[i] = false;
        }
      }
      console.log("this.selectedWeekdays:", this.selectedWeekdays);
    },
    // 选择周几
    selectWeekday() {
      console.log("this.selectedWeekdays:", this.selectedWeekdays);
    },
    // 点击周几文字，也是选择周几
    clickWeekdayWord(weekdayIndex) {
      this.selectedWeekdays[weekdayIndex] = !this.selectedWeekdays[weekdayIndex];
      this.selectWeekday();
    },
    // 全选时间段
    selectAllPeriod(weekdayIndex) {
      if (this.selectedAllPeriod[weekdayIndex]) {
        // 全选
        this.selectedWeekdayPeriods[weekdayIndex] = [...this.classList[this.selectedClassIndex].periods];
      } else {
        // 取消全选
        this.selectedWeekdayPeriods[weekdayIndex] = [];
      }
    },
    /////////////////////
    // 快速排课页面
    // 退出快速排课页面
    cancelQuickArrange() {
      this.showCourseArrangeStep2 = false;
    },
    // // 点击选择周几，某个时间段，老师可排课数 (周几，时间段，老师id)
    // 这个老师冲突的时间段置灰/恢复
    // 再调用teacherQuickArrangeCourseNumChange完成下面功能
    // 重新计算每个老师，每个时间段可排课次数
    // 重新计算每个老师的可排课数合计
    // 重新计算每个老师，添加的每个课 可排课次数
    selectWeekdayPeriodTeacherChange(index, item2, item3) {
      let oriTeacherAvailableNum = this.teacherAvailableNum[item3];

      // 先找出周几有哪些时间段 和 选择的时间段 冲突
      let periodList = [];
      for (let period in this.weekdayPeriodTeacherAvailableNum[index]) {
        if (this.periodIsConflict(item2, period)) {
          periodList.push(period);
        }
      }

      // 如果是选中
      if (this.weekdayPeriodTeacherIfSelected[index][item2][item3] == true) {
        // 冲突的时间段置灰
        for (let i in periodList) {
          let period = periodList[i];
          for (let teacherId in this.weekdayPeriodTeacherIfSelected[index][period]) {
            // 跳过 当前老师的当前时间段
            if (period == item2 && teacherId == item3) {
              continue;
            }

            // 每个老师 冲突的时间段都置灰
            // this.ifCanSelectWeekdayPeriodTeacher[index][period][
            //   teacherId
            // ] = false;

            // 只置灰当前老师冲突的时间段
            if (teacherId == item3) {
              // 置灰
              this.ifCanSelectWeekdayPeriodTeacher[index][period][teacherId] = false;
            }
          }
        }

        // console.log(
        //   "this.ifCanSelectWeekdayPeriodTeacher:",
        //   this.ifCanSelectWeekdayPeriodTeacher
        // );

        // console.log(
        //   "this.weekdayPeriodTeacherAvailableNum[index][item2][item3]:",
        //   this.weekdayPeriodTeacherAvailableNum[index][item2][item3]
        // );

        // 重新计算这个老师的可排课数合计
        this.teacherAvailableNum[item3] = this.teacherAvailableNum[item3] + this.weekdayPeriodTeacherAvailableNum[index][item2][item3];
      }
      // 如果是取消选中
      else {
        // 之前冲突的时间段，置灰的，恢复
        for (let i in periodList) {
          let period = periodList[i];
          for (let teacherId in this.weekdayPeriodTeacherIfSelected[index][period]) {
            // 所有老师 置灰，恢复
            // this.ifCanSelectWeekdayPeriodTeacher[index][period][
            //   teacherId
            // ] = true;

            // 只恢复当前老师
            if (teacherId == item3) {
              // 置灰，恢复
              this.ifCanSelectWeekdayPeriodTeacher[index][period][teacherId] = true;
            }
          }
        }

        // 重新计算这个老师的可排课数
        this.teacherAvailableNum[item3] = this.teacherAvailableNum[item3] - this.weekdayPeriodTeacherAvailableNum[index][item2][item3];
      }
      console.log("this.teacherAvailableNum:", this.teacherAvailableNum);

      // 如果老师的合计可排课次数减少了，老师的每个科目的排课次数要重置为0
      if (this.teacherAvailableNum[item3] < oriTeacherAvailableNum) {
        if (this.teacherCourseArrangeNum[item3]) {
          // 老师每个科目排课次数重置为0
          for (let j in this.teacherCourseArrangeNum[item3]) {
            this.teacherCourseArrangeNum[item3][j][Object.keys(this.teacherCourseArrangeNum[item3][j])[0]] = 0;
          }
        }
      }

      //重新计算其他老师，每个时间段可排课次数
      //重新计算这个老师，添加的每个课 可排课次数
      this.teacherQuickArrangeCourseNumChange(item3, 0);
    },
    // 快速排课 可排课次分配，点击添加科目
    // 找出这个老师，在这个班级 教授的科目
    addTeacherQuickArrangeCourse(teacherId) {
      // 找出老师索引
      let teacherIndex;
      for (let i in this.teacherList) {
        if (this.teacherList[i].id == teacherId) {
          teacherIndex = i;
        }
      }
      this.quickArrangeTeacherId = teacherId;
      this.teacherQuickArrangeCourseName = "";
      if (this.teacherAvailableNum[teacherId] == 0) {
        alert("这个老师可排课次数为0，不能添加课程");
        return;
      }

      // 找出这个老师，在这个班级 教授的科目
      this.teacherClassCourseList = [];
      for (let i in this.teacherList[teacherIndex].courses) {
        // 这个班级的科目
        if (this.classList[this.selectedClassIndex].courses.includes(this.teacherList[teacherIndex].courses[i])) {
          this.teacherClassCourseList.push(this.teacherList[teacherIndex].courses[i]);
        }
      }
      this.showAddTeacherQuickArrangeCourse = true;
    },
    // // 快速排课 可排课次分配，确定添加科目
    // 计算科目的可排课次数
    addTeacherQuickArrangeCourseConfirm() {
      if (!this.teacherQuickArrangeCourseName) {
        alert("请选择课程");
        return;
      }

      //如果这个老师还没有添加课程，初始化
      if (!this.teacherCourseArrangeNum[this.quickArrangeTeacherId]) {
        this.teacherCourseArrangeNum[this.quickArrangeTeacherId] = [];
      }

      //添加课程名不能重复
      for (let i = 0; i < this.teacherCourseArrangeNum[this.quickArrangeTeacherId].length; i++) {
        if (this.teacherCourseArrangeNum[this.quickArrangeTeacherId][i][this.teacherQuickArrangeCourseName] != undefined) {
          alert("课程名不能重复");
          return;
        }
      }

      //添加的课程，初始排课次数=0
      let obj = {};
      obj[this.teacherQuickArrangeCourseName] = 0;
      this.teacherCourseArrangeNum[this.quickArrangeTeacherId].push(obj);
      console.log("老师快速排课的科目 this.teacherCourseArrangeNum:", this.teacherCourseArrangeNum);

      //这个老师第一次添加科目，第一个科目的可排课次数=合计可排课次数
      if (this.teacherCourseArrangeNum[this.quickArrangeTeacherId].length == 1) {
        // 初始化
        if (this.teacherCourseAvailableNum[this.quickArrangeTeacherId] == undefined) {
          this.teacherCourseAvailableNum[this.quickArrangeTeacherId] = [];
        }
        this.teacherCourseAvailableNum[this.quickArrangeTeacherId][0] = this.teacherAvailableNum[this.quickArrangeTeacherId];
      }
      //如果不是第一次添加科目，科目可排课次数=合计可排课次数-其他科目排课次数
      else {
        // 有几个科目
        let len = this.teacherCourseArrangeNum[this.quickArrangeTeacherId].length;
        let restNum = this.teacherAvailableNum[this.quickArrangeTeacherId];
        for (let i = 0; i < len - 1; i++) {
          restNum = restNum - Object.values(this.teacherCourseArrangeNum[this.quickArrangeTeacherId][i])[0];
        }
        this.teacherCourseAvailableNum[this.quickArrangeTeacherId][len - 1] = restNum;
      }
      console.log("this.teacherCourseAvailableNum:", this.teacherCourseAvailableNum);
      this.showAddTeacherQuickArrangeCourse = false;
    },
    addTeacherQuickArrangeCourseCancel() {
      this.showAddTeacherQuickArrangeCourse = false;
    },
    // 所有老师的课重新排 （策略1，优先排完一个老师，优先排完一个科目）
    quickArrangeCourse1() {
      // 待排课的课程数组 [{teacherId: 1, courseName: '语文'}]
      let courseArray = [];
      // 按老师顺序
      for (let teacherIndex in this.teacherList) {
        let teacherId = this.teacherList[teacherIndex].id;
        // 如果这个班级没有这个老师，下一个老师
        if (!this.classList[this.selectedClassIndex].teacherIds.includes(teacherId)) {
          continue;
        }
        // 如果这个老师没有安排课程，下一个老师
        if (!this.teacherCourseArrangeNum[teacherId]) {
          continue;
        }
        if (this.teacherCourseArrangeNum[teacherId].length == 0) {
          continue;
        }

        // 每个科目
        for (let courseIndex in this.teacherCourseArrangeNum[teacherId]) {
          let courseName = Object.keys(this.teacherCourseArrangeNum[teacherId][courseIndex])[0];
          let courseNum = Object.values(this.teacherCourseArrangeNum[teacherId][courseIndex])[0];

          // 如果这个科目安排的课次是0，下一个科目
          if (courseNum == 0) {
            continue;
          }
          for (let i = 0; i < courseNum; i++) {
            courseArray.push({
              teacherId: teacherId,
              courseName: courseName
            });
          }
        }
      }

      //获取老师选择的日期和时间段数组
      let teacherSelectDatePeriodArray = {};
      let teacherSelectDatePeriodArrayCurrentIndex = {};
      for (let teacherId in this.teacherCourseArrangeNum) {
        //获取老师选择的日期和时间段数组
        let ret = this.getTeacherSelectDatePeriodArray(teacherId);
        teacherSelectDatePeriodArray[teacherId] = ret;
        teacherSelectDatePeriodArrayCurrentIndex[teacherId] = 0;
      }

      // 重置动态变量为初始值
      this.datePeriodArrangement = JSON.parse(JSON.stringify(this.oriDatePeriodArrangement));
      this.teacherDatePeriodIfAvailable = JSON.parse(JSON.stringify(this.oriTeacherDatePeriodIfAvailable));
      // 根据待排课的课程数组，逐个排课
      for (let i = 0; i < courseArray.length; i++) {
        let teacherId = courseArray[i].teacherId;
        let courseName = courseArray[i].courseName;

        // 老师选择的排课日期和时间段
        for (let j = teacherSelectDatePeriodArrayCurrentIndex[teacherId]; j < teacherSelectDatePeriodArray[teacherId].length; j++) {
          let date = teacherSelectDatePeriodArray[teacherId][j].date;
          let period = teacherSelectDatePeriodArray[teacherId][j].period;

          // 如果这个日期，这个时间段，这个老师可以排课
          if (this.teacherDatePeriodIfAvailable[teacherId][date][period]) {
            this.datePeriodArrangement[date][period] = {
              teacherId: teacherId,
              classroomId: this.teacherDatePeriodIfAvailable[teacherId][date][period][0],
              course: courseName
            };
            teacherSelectDatePeriodArrayCurrentIndex[teacherId] = j + 1;

            // 每排一次课，就要更新 teacherDatePeriodIfAvailable
            for (let otherPeriod in this.teacherDatePeriodIfAvailable[teacherId][date]) {
              if (otherPeriod == period) {
                continue;
              }

              // 与排课时间冲突的时间段，置为不可排课
              if (this.periodIsConflict(period, otherPeriod)) {
                // 每个老师都要置为不可排课
                for (let otherTeacherId in this.teacherDatePeriodIfAvailable) {
                  this.teacherDatePeriodIfAvailable[otherTeacherId][date][otherPeriod] = 0;
                }
              }
            }

            // 排完这节课，排下一节课
            break;
          }
          // 如果这个老师这个时间段没空，就下一个时间段
          else {
            continue;
          }
        }
      }
    },
    // 所有老师的课重新排 （策略2，每个老师科目排一次）
    quickArrangeCourse2() {},
    // // 选择老师的科目排课次数后
    // 所有老师的课重新排
    // 重新计算每个老师的每个时间段可排课数
    // 重新计算每个老师的可排课数合计
    // 重新计算每个老师每个科目可排课次数
    teacherQuickArrangeCourseNumChange(teacherId, index2) {
      // 先重新给所有老师排课
      this.quickArrangeCourse1();

      // 计算每个老师，每个时间段可排次数
      // 计算每个老师，合计可排次数
      for (let otherTeacherId of this.classList[this.selectedClassIndex].teacherIds) {
        // // 如果是这个老师，跳过
        // if (otherTeacherId == teacherId) {
        //   continue;
        // }

        // 每个老师每个时间段可排次数 重置为0，重新计算
        for (let weekdayIndex in this.weekdayPeriodTeacherAvailableNum) {
          for (let period in this.weekdayPeriodTeacherAvailableNum[weekdayIndex]) {
            this.weekdayPeriodTeacherAvailableNum[weekdayIndex][period][otherTeacherId] = 0;
          }
        }
        // 每个老师，合计可排次数 重置为0，重新计算
        this.teacherAvailableNum[otherTeacherId] = 0;

        //重新计算 每个老师每个时间段可排次数
        //重新计算 每个老师 合计可排次数
        for (let date in this.datePeriodArrangement) {
          for (let period in this.datePeriodArrangement[date]) {
            let canArrange = true;

            // 这个日期的每个时间段
            for (let period2 in this.datePeriodArrangement[date]) {
              //和这个时间段冲突的时间段
              if (this.periodIsConflict(period, period2)) {
                // 只要有一个冲突的时间段已经有安排，并且安排的不是这个老师，那这个时间段就不可以排课
                if (this.datePeriodArrangement[date][period2] != 1 && this.datePeriodArrangement[date][period2].teacherId != otherTeacherId) {
                  canArrange = false;
                  break;
                }
              }
            }
            // 如果这个时间段不能排课，下一个时间段
            if (!canArrange) {
              continue;
            }

            // 如果这个日期，这个时间段可以安排老师
            if (this.datePeriodArrangement[date][period] == 1) {
              // 如果这个老师，这个日期，这个时间段可以排课
              if (this.teacherDatePeriodIfAvailable[otherTeacherId][date][period]) {
                // 老师周几这个时间段可排课次+1
                // 获取这个日期是周几
                const dateFormat = new Date(date);
                const dayIndex = dateFormat.getDay(); //0周日，6周六
                let weekdayIndex = dayIndex - 1;
                if (dayIndex == 0) {
                  weekdayIndex = 6;
                }
                this.weekdayPeriodTeacherAvailableNum[weekdayIndex][period][otherTeacherId] = this.weekdayPeriodTeacherAvailableNum[weekdayIndex][period][otherTeacherId] + 1;

                // 如果这个日期，这个时间段，这个老师被选中了
                if (this.weekdayPeriodTeacherIfSelected[weekdayIndex][period][otherTeacherId] === true) {
                  // 这个老师，合计可排次数+1
                  this.teacherAvailableNum[otherTeacherId] = this.teacherAvailableNum[otherTeacherId] + 1;
                }
              }
            }
            // 如果不可以安排老师
            else {
              // 如果本来就是这个老师
              if (this.datePeriodArrangement[date][period].teacherId == otherTeacherId) {
                // 老师周几这个时间段可排课次+1
                // 获取这个日期是周几
                const dateFormat = new Date(date);
                const dayIndex = dateFormat.getDay(); //0周日，6周六
                let weekdayIndex = dayIndex - 1;
                if (dayIndex == 0) {
                  weekdayIndex = 6;
                }
                this.weekdayPeriodTeacherAvailableNum[weekdayIndex][period][otherTeacherId] = this.weekdayPeriodTeacherAvailableNum[weekdayIndex][period][otherTeacherId] + 1;

                // 如果这个日期，这个时间段，这个老师 被选中了
                if (this.weekdayPeriodTeacherIfSelected[weekdayIndex][period][otherTeacherId] === true) {
                  // 这个老师，合计可排次数+1
                  this.teacherAvailableNum[otherTeacherId] = this.teacherAvailableNum[otherTeacherId] + 1;
                }
              }
            }
          }
        }
      }

      // 计算每个老师，每个科目可分配次数
      for (let otherTeacherId of this.classList[this.selectedClassIndex].teacherIds) {
        // 每个科目
        for (let i in this.teacherCourseArrangeNum[otherTeacherId]) {
          // 初始 每个科目可排课次数 = 老师合计可排课次数
          this.teacherCourseAvailableNum[otherTeacherId][i] = this.teacherAvailableNum[otherTeacherId];

          //减去其他所有科目的次数
          for (let j in this.teacherCourseArrangeNum[otherTeacherId]) {
            // 如果是这个科目，跳过
            if (j == i) {
              continue;
            }

            //减去其他所有科目的次数
            this.teacherCourseAvailableNum[otherTeacherId][i] = this.teacherCourseAvailableNum[otherTeacherId][i] - Object.values(this.teacherCourseArrangeNum[otherTeacherId][j])[0];
          }
        }
      }
    },
    //老师选的周几，时间段，转为日期数组
    getTeacherSelectDatePeriodArray(teacherId) {
      // 老师选了周几哪些时间段
      let teacherSelectWeekdayPeriod = {};
      // 周几
      for (let weekdayIndex in this.weekdayPeriodTeacherIfSelected) {
        weekdayIndex = parseInt(weekdayIndex);
        teacherSelectWeekdayPeriod[weekdayIndex] = {};
        for (let period in this.weekdayPeriodTeacherIfSelected[weekdayIndex]) {
          // 老师选了周几哪些时间段
          if (this.weekdayPeriodTeacherIfSelected[weekdayIndex][period][teacherId] === true) {
            teacherSelectWeekdayPeriod[weekdayIndex][period] = true;
          }
        }
      }

      //选择的周几和时间段，转换为日期和时间段，按时间顺序排成数组
      //获取快速排课的日期段的每天，包括补齐前后周
      let monthDates = this.getCompleteDateRange(this.quickArrangeDateRange[0], this.quickArrangeDateRange[1]);
      //日期段内有几周
      let weekNum = monthDates.length / 7;
      //日期和时间段数组
      let teacherSelectDatePeriodArray = [];
      //每周
      for (let weekIndex = 0; weekIndex < weekNum; weekIndex++) {
        //周几
        for (let weekdayIndex in teacherSelectWeekdayPeriod) {
          weekdayIndex = parseInt(weekdayIndex);

          // 如果这个日期是补齐的，下一个
          if (monthDates[weekIndex * 7 + weekdayIndex].ifGrey) {
            continue;
          }

          //选择的日期和时间段，按日期顺序排成数组
          for (let period in teacherSelectWeekdayPeriod[weekdayIndex]) {
            //
            teacherSelectDatePeriodArray.push({
              date: monthDates[weekIndex * 7 + weekdayIndex].completeDate,
              period: period
            });
          }
        }
      }
      return teacherSelectDatePeriodArray;
    },
    // 判断两个时间段hh:mm-hh:mm是不是有冲突
    periodIsConflict(period1, period2) {
      let period1StartTime = period1.split("-")[0];
      let period1EndTime = period1.split("-")[1];
      let period2StartTime = period2.split("-")[0];
      let period2EndTime = period2.split("-")[1];
      if (period1StartTime >= period2StartTime && period1StartTime < period2EndTime) {
        return true;
      }
      if (period1EndTime > period2StartTime && period1EndTime <= period2EndTime) {
        return true;
      }
      if (period1StartTime <= period2StartTime && period1EndTime >= period2EndTime) {
        return true;
      }
      return false;
    },
    //预览快速排课结果
    async quickArrangePreview() {
      // const scrollContainer = document.getElementById("scrollArea");
      //   console.log("scrollContainer.scrollTop:", scrollContainer.scrollTop);

      //loading界面
      const loading = ElLoading.service({
        lock: true,
        text: "处理中...",
        background: "rgba(0, 0, 0, 0.7)"
      });
      try {
        // 得到快速排课的课程安排
        this.quickArrangeCourseList = {};
        for (let date in this.datePeriodArrangement) {
          if (!this.quickArrangeCourseList[date]) {
            this.quickArrangeCourseList[date] = {};
          }
          for (let period in this.datePeriodArrangement[date]) {
            // 如果有内容，就是排了课
            if (this.datePeriodArrangement[date][period].course) {
              // 添加到快速排课列表
              this.quickArrangeCourseList[date][period] = {
                classId: this.classList[this.selectedClassIndex].id,
                date: date,
                period: period,
                teacherId: this.datePeriodArrangement[date][period].teacherId,
                classroomId: this.datePeriodArrangement[date][period].classroomId,
                course: this.datePeriodArrangement[date][period].course
              };
            }
          }
        }

        // 将之前的课程安排也展示到预览中，加阴影区分
        // 预览的时间段，如果不只是当月，还要获取其他月份的课程安排
        // 预览的时间段内所有课程安排
        let courseArrangeList = {};
        // 获取时间段内有几个月
        const months = [];
        const currentMonth = moment(this.quickArrangeDateRange[0]).startOf("month");
        const endMonth = moment(this.quickArrangeDateRange[1]).endOf("month");
        while (currentMonth.isSameOrBefore(endMonth, "month")) {
          months.push(currentMonth.format("YYYY-MM"));
          currentMonth.add(1, "month");
        }
        // 如果只有当月，不用再调用后端获取排课
        if (months.length == 1 && months[0] == this.currentMonth) {
          courseArrangeList = this.courseArrangeList;
        }
        // 否则调用后端获取每个月的排课
        else {
          //loading界面
          const loading = ElLoading.service({
            lock: true,
            text: "处理中...",
            background: "rgba(0, 0, 0, 0.7)"
          });
          try {
            for (let month of months) {
              const firstDay = moment(`${month}-01`).format("YYYY-MM-DD");

              // 获取当月最后一天
              const lastDay = moment(`${month}-01`).endOf("month").format("YYYY-MM-DD");
              let params = {
                classId: this.classList[this.selectedClassIndex].id,
                startDate: firstDay,
                endDate: lastDay
              };
              let resp1 = await axios.post("https://backend.wonology.com/courseArrange/courseArrange/getClassCourseArrange", params);
              if (resp1.data.code == "0000") {
                let monthCourseArrangeList = resp1.data.data;
                for (let date in monthCourseArrangeList) {
                  for (let period in monthCourseArrangeList[date]) {
                    if (!courseArrangeList[date]) {
                      courseArrangeList[date] = {};
                    }
                    courseArrangeList[date][period] = monthCourseArrangeList[date][period];
                  }
                }
              } else {
                console.log("调用getClassCourseArrange出错:", resp1.data.msg);
                alert("调用后端出错: " + resp1.data.msg);
              }
            }
          } catch (error) {
            console.log("catch error:", error);
            alert("catch error " + error);
          } finally {
            loading.close();
          }
        }

        // 将快速排课 和 已有排课 合并
        //获取快速排课的日期段的每天，包括补齐前后周
        this.monthDates = this.getCompleteDateRange(this.quickArrangeDateRange[0], this.quickArrangeDateRange[1]);
        // console.log("this.monthDates:", this.monthDates);
        for (let dateIndex in this.monthDates) {
          let date = this.monthDates[dateIndex].completeDate;
          if (courseArrangeList[date]) {
            // 每个课都加入 quickArrangeCourseList
            for (let period in courseArrangeList[date]) {
              // 已安排的课加一个标志
              courseArrangeList[date][period]["alreadyArranged"] = true;
              if (!this.quickArrangeCourseList[date]) {
                this.quickArrangeCourseList[date] = {};
              }
              this.quickArrangeCourseList[date][period] = courseArrangeList[date][period];
            }
          }
        }
        console.log("this.quickArrangeCourseList:", this.quickArrangeCourseList);

        //展示预览页面
        this.showQuickArrangePreview = true;

        // const scrollContainer = document.getElementById("scrollArea");
        // console.log("scrollContainer.scrollTop:", scrollContainer.scrollTop);
      } catch (err) {
        console.log("catch error: " + err);
        alert("catch error: " + err);
      } finally {
        loading.close();
      }
    },
    // 获取指定日期段内所有日期，包括补齐前后周
    getCompleteDateRange(startDate, endDate) {
      const dates = [];
      const weekdays = ["周日", "周一", "周二", "周三", "周四", "周五", "周六"];

      // 解析开始和结束日期
      const start = new Date(startDate);
      const end = new Date(endDate);

      // 1. 处理开始日期前的补齐
      const firstDay = new Date(start);
      let firstWeekDay = firstDay.getDay(); // 0=周日, 1=周一, ...

      // 如果第一天不是周一，向前补齐到周一
      if (firstWeekDay !== 1) {
        // 调整：周日(0)应该视为第7天，周一(1)是第1天
        if (firstWeekDay === 0) firstWeekDay = 7;

        // 向前补齐到周一
        for (let i = firstWeekDay - 1; i >= 1; i--) {
          const previousDay = new Date(firstDay);
          previousDay.setDate(firstDay.getDate() - i);
          const year = previousDay.getFullYear();
          const month = (previousDay.getMonth() + 1).toString().padStart(2, "0");
          const day = previousDay.getDate().toString().padStart(2, "0");
          const completeDate = `${year}-${month}-${day}`;
          dates.push({
            date: previousDay.getDate(),
            completeDate: completeDate,
            dayOfWeek: previousDay.getDay(),
            dayOfWeekText: weekdays[previousDay.getDay()],
            ifGrey: true // 补齐的日期标记为灰色
          });
        }
      }

      // 2. 添加日期范围内的所有日期
      const current = new Date(start);
      while (current <= end) {
        const year = current.getFullYear();
        const month = (current.getMonth() + 1).toString().padStart(2, "0");
        const day = current.getDate().toString().padStart(2, "0");
        const completeDate = `${year}-${month}-${day}`;
        dates.push({
          date: current.getDate(),
          completeDate: completeDate,
          dayOfWeek: current.getDay(),
          dayOfWeekText: weekdays[current.getDay()],
          ifGrey: false // 正常日期不标记为灰色
        });
        current.setDate(current.getDate() + 1);
      }

      // 3. 处理结束日期后的补齐
      const lastDay = new Date(end);
      let lastWeekDay = lastDay.getDay(); // 0=周日, 1=周一, ...

      // 如果最后一天不是周日，向后补齐到周日
      if (lastWeekDay !== 0) {
        // 向后补齐到周日
        for (let i = 1; i <= 7 - lastWeekDay; i++) {
          const nextDay = new Date(lastDay);
          nextDay.setDate(lastDay.getDate() + i);
          const year = nextDay.getFullYear();
          const month = (nextDay.getMonth() + 1).toString().padStart(2, "0");
          const day = nextDay.getDate().toString().padStart(2, "0");
          const completeDate = `${year}-${month}-${day}`;
          dates.push({
            date: nextDay.getDate(),
            completeDate: completeDate,
            dayOfWeek: nextDay.getDay(),
            dayOfWeekText: weekdays[nextDay.getDay()],
            ifGrey: true // 补齐的日期标记为灰色
          });
        }
      }
      return dates;
    },
    ///////
    // 快速排课预览页面
    async insertQuickArrange() {
      //loading界面
      const loading = ElLoading.service({
        lock: true,
        text: "处理中...",
        background: "rgba(0, 0, 0, 0.7)"
      });

      //去掉预览的课程中，已安排的课程
      let quickArrangeCourseList = {};
      for (let date in this.quickArrangeCourseList) {
        for (let period in this.quickArrangeCourseList[date]) {
          if (this.quickArrangeCourseList[date][period]["alreadyArranged"] == true) {
            continue;
          } else {
            if (!quickArrangeCourseList[date]) {
              quickArrangeCourseList[date] = {};
            }
            quickArrangeCourseList[date][period] = this.quickArrangeCourseList[date][period];
          }
        }
      }
      try {
        let params = {
          username: this.username,
          institution: this.institution,
          quickArrangeCourseList: quickArrangeCourseList
        };
        let resp1 = await axios.post("https://backend.wonology.com/courseArrange/courseArrange/insertQuickArrange", params);
        if (resp1.data.code == "0000") {} else {
          console.log("调用后端出错:", resp1.data.msg);
          alert("调用后端出错: " + resp1.data.msg);
        }
      } catch (error) {
        console.log("catch error:", error);
        alert("catch error " + error);
      } finally {
        loading.close();
      }
      await this.getClassCourseArrange();
      await this.getTeacherCourseArrange();
      if (this.studentList.length > 0) {
        await this.getStudentCourseArrange();
      }
      this.getMonthInfo();
      this.showQuickArrangePreview = false;
      this.showCourseArrangeStep2 = false;
      this.showCourseArrangeStep1 = false;
    },
    cancelQuickArrangePreview() {
      this.getMonthInfo();
      this.showQuickArrangePreview = false;
    },
    //////////
    // 新增班级 弹窗
    //选择开班结班日期
    selectDateRange() {
      console.log("this.selectedDateRange:", this.selectedDateRange);

      // 如果清除了日期段
      if (this.selectedDateRange == null) {
        this.selectedStartDate = "";
        this.selectedEndDate = "";
        return;
      }
      this.selectedStartDate = this.selectedDateRange[0];
      this.selectedEndDate = this.selectedDateRange[1];
    },
    // 选择教授科目
    selectCourseChange() {
      // 获取这些科目哪些老师能教
    },
    // 选择任课老师
    selectTeacherIdsChange() {
      // console.log("this.selectedTeacherIds:", this.selectedTeacherIds);

      //获取任课老师教的科目
      this.teachersCourseList = [];
      // 选择的每个老师
      for (let i in this.selectedTeacherIds) {
        let teacherId = this.selectedTeacherIds[i];
        const index = this.teacherList.findIndex(item => item.id == teacherId);

        // 如果老师不存在，则跳过
        if (index == -1) {
          console.log("teacherId:", teacherId);
          console.log("老师不存在，跳过");

          // alert(`老师'${this.teacherNames[teacherId]}'未启用`)

          continue;
        }

        // console.log("index:", index)
        // console.log("this.teacherList:", this.teacherList)
        // console.log("this.teacherList[index]:", this.teacherList[index])

        for (let j in this.teacherList[index].courses) {
          if (!this.teachersCourseList.includes(this.teacherList[index].courses[j])) {
            this.teachersCourseList.push(this.teacherList[index].courses[j]);
          }
        }
      }

      // 选择老师，自动选择老师教授的所有科目
      // this.selectedCourses = this.teachersCourseList;
    },
    //添加/修改班级
    addClass(tag) {
      // 如果是修改班级，获取变量
      if (tag == "modify") {
        this.className = this.classList[this.selectedClassIndex].name;
        this.selectedStartDate = this.classList[this.selectedClassIndex].startDate;
        this.selectedEndDate = this.classList[this.selectedClassIndex].endDate;
        this.selectedDateRange = [this.selectedStartDate, this.selectedEndDate];
        this.totalClassHour = this.classList[this.selectedClassIndex].totalHour;
        this.selectedTeacherIds = this.classList[this.selectedClassIndex].teacherIds;
        this.selectedCourseType = this.classList[this.selectedClassIndex].courseType;
        this.selectedCampusId = this.classList[this.selectedClassIndex].campusId;
        this.selectedPeriods = this.classList[this.selectedClassIndex].periods;
        this.selectedTimeRangeStr = "";
        for (let i in this.selectedPeriods) {
          this.selectedTimeRangeStr = this.selectedTimeRangeStr + this.selectedPeriods[i] + "/";
        }
        this.selectedCourses = this.classList[this.selectedClassIndex].courses;
        this.remark = this.classList[this.selectedClassIndex].remark;

        //获取科目下拉框选项
        this.selectTeacherIdsChange();
        this.addClassTag = "modify";
      }
      // 如果是新增班级，变量重置
      else {
        this.className = "";
        this.selectedStartDate = "";
        this.selectedEndDate = "";
        this.selectedDateRange = [];
        this.totalClassHour = "";
        this.selectedTeacherIds = [];
        this.selectedCourseType = "";
        this.selectedCampusId = "";
        this.selectedPeriods = [];
        this.selectedTimeRangeStr = "";
        this.selectedCourses = [];
        this.remark = "";
        this.addClassTag = "";
      }
      this.showAddClass = true;
    },
    async addClassConfirm() {
      const t0 = Date.now();

      // 先判断有没有老师有科目 没设置单价
      let ret = await this.ifCourseSetFee();
      if (!ret) {
        this.showTip = true;
        this.tipMessage = "请先设置老师课程单价";

        // 注册resolve函数 （和回调还是有点区别，不过这个方法更好）
        // 后面通过 this.tipResolver(value) 返回值
        const tipConfirmed = await new Promise(resolve => {
          this.tipResolver = resolve;
        });
        if (tipConfirmed === "confirm") {
          // 用户选择确认，继续执行

          this.showSetFee = true;
          return;
        } else {
          // 用户选择取消，返回

          return;
        }
      }

      //loading界面
      const loading = ElLoading.service({
        lock: true,
        text: "处理中...",
        background: "rgba(0, 0, 0, 0.7)"
      });
      try {
        if (this.className && this.selectedStartDate && this.totalClassHour && this.selectedTeacherIds.length && this.selectedCourses.length && this.selectedCourseType && this.selectedEndDate && this.selectedCampusId && this.selectedPeriods.length) {} else {
          console.log("请填写所有内容");
          alert("请填写所有内容");
          return;
        }
        let params = {
          addClassTag: this.addClassTag,
          institution: this.institution,
          className: this.className,
          selectedStartDate: this.selectedStartDate,
          totalClassHour: this.totalClassHour,
          selectedTeacherIds: this.selectedTeacherIds,
          selectedCourses: this.selectedCourses,
          selectedCourseType: this.selectedCourseType,
          selectedEndDate: this.selectedEndDate,
          selectedPeriods: this.selectedPeriods,
          selectedCampusId: this.selectedCampusId,
          remark: this.remark
        };
        if (this.addClassTag == "modify") {
          params.classId = this.classList[this.selectedClassIndex].id;

          //如果任课老师有变动，判断老师是否已安排课程
          for (let date in this.courseArrangeList) {
            for (let period in this.courseArrangeList[date]) {
              // 如果班级的老师里 没有已安排课程的老师，不让修改
              if (!this.selectedTeacherIds.includes(this.courseArrangeList[date][period].teacherId)) {
                alert(`老师'${this.teacherNames[this.courseArrangeList[date][period].teacherId]}'已排课，不能删除该任课老师`);
                this.addClass("modify");
                return;
              }

              //如果教授科目有变动，判断科目是否已安排课程
              if (!this.selectedCourses.includes(this.courseArrangeList[date][period].course)) {
                alert(`科目'${this.courseArrangeList[date][period].course}'已排课，不能删除该科目`);
                this.addClass("modify");
                return;
              }
            }
          }
        }
        // 选择的科目，没有一个是某个老师可以教的科目时，提示
        let teacherCourses = {};
        for (let j in this.teacherList) {
          if (this.selectedTeacherIds.includes(this.teacherList[j].id)) {
            teacherCourses[this.teacherList[j].id] = [];
            for (let i in this.selectedCourses) {
              if (this.teacherList[j].courses.includes(this.selectedCourses[i])) {
                teacherCourses[this.teacherList[j].id].push(this.selectedCourses[i]);
              }
            }
            if (teacherCourses[this.teacherList[j].id].length == 0) {
              alert(`选择的科目中没有'${this.teacherNames[this.teacherList[j].id]}'教的科目`);
              return;
            }
          }
        }
        const t1 = Date.now();
        let resp1 = await axios.post("https://backend.wonology.com/courseArrange/courseArrange/addClass", params);
        if (resp1.data.code == "0000") {
          // this.classId = resp1.data.data.insertId;

          const dtAddClass = Date.now() - t1;
          if (dtAddClass > SLOW_STEP_LOG_MS) {
            console.log(`调用/courseArrange/courseArrange/addClass用时： ${dtAddClass}ms (>${SLOW_STEP_LOG_MS}ms)`);
          }

          // 下面更新classlist，需要先保存id，再重新更新selectedClassIndex
          let classId = this.classList[this.selectedClassIndex].id;
          const t2 = Date.now();
          // 更新班级列表
          await this.getClassList();
          const dtGetClassList = Date.now() - t2;
          if (dtGetClassList > SLOW_STEP_LOG_MS) {
            console.log(`调用this.getClassList()用时： ${dtGetClassList}ms (>${SLOW_STEP_LOG_MS}ms)`);
          }

          // 上面更新classlist，修改this.selectedClassIndex
          this.selectedClassIndex = this.classList.findIndex(classObj => classObj.id === classId);
          this.showAddClass = false;
        } else {
          console.log("调用后端出错:", resp1.data.msg);
          alert("调用后端出错: " + resp1.data.msg);
        }
      } catch (error) {
        console.log("catch error:", error);
        alert("catch error " + error);
      } finally {
        loading.close();
      }
      const dtAddClassAll = Date.now() - t0;
      if (dtAddClassAll > SLOW_STEP_LOG_MS) {
        console.log(`添加/修改班级总用时： ${dtAddClassAll}ms (>${SLOW_STEP_LOG_MS}ms)`);
      }
    },
    addClassCancel() {
      this.showAddClass = false;
    },
    // 判断科目是否已设置单价
    async ifCourseSetFee() {
      //loading界面
      const loading = ElLoading.service({
        lock: true,
        text: "处理中...",
        background: "rgba(0, 0, 0, 0.7)"
      });
      try {
        let params = {
          teacherIds: this.selectedTeacherIds,
          courseType: this.selectedCourseType,
          courses: this.selectedCourses,
          effectiveDate: this.selectedStartDate || moment().format("YYYY-MM-DD")
        };
        let resp1 = await axios.post("https://backend.wonology.com/courseArrange/courseArrange/ifCourseSetFee", params);
        if (resp1.data.code == "0000") {
          this.ifTeacherCourseTypeSetFee = resp1.data.data;
          return resp1.data.flag;
        } else {
          console.log("调用后端出错:", resp1.data.msg);
          alert("调用后端出错: " + resp1.data.msg);
          return false;
        }
      } catch (error) {
        console.log("catch error:", error);
        alert("catch error " + error);
      } finally {
        loading.close();
      }
    },
    // 保存单价
    async saveFeeSetting() {
      //loading界面
      const loading = ElLoading.service({
        lock: true,
        text: "处理中...",
        background: "rgba(0, 0, 0, 0.7)"
      });
      try {
        // console.log("this.ifTeacherCourseTypeSetFee", this.ifTeacherCourseTypeSetFee)

        // 判断是否有科目没有设置单价
        for (let teacherId in this.ifTeacherCourseTypeSetFee) {
          for (let course in this.ifTeacherCourseTypeSetFee[teacherId]) {
            for (let courseType in this.ifTeacherCourseTypeSetFee[teacherId][course]) {
              if (this.ifTeacherCourseTypeSetFee[teacherId][course][courseType] === false) {
                alert(`请设置'${this.teacherNames[teacherId]}'的'${course}'的'${courseType}'的课时单价`);
                return;
              }
            }
          }
        }
        let params = {
          teacherCourseTypeSetFee: this.ifTeacherCourseTypeSetFee,
          effectiveDate: this.selectedStartDate || moment().format("YYYY-MM-DD"),
          username: this.username
        };
        let resp1 = await axios.post("https://backend.wonology.com/courseArrange/courseArrange/saveCourseFee", params);
        if (resp1.data.code == "0000") {
          this.showSetFee = false;
        } else {
          console.log("调用后端出错:", resp1.data.msg);
          alert("调用后端出错: " + resp1.data.msg);
        }
      } catch (error) {
        console.log("catch error:", error);
        alert("catch error " + error);
      } finally {
        loading.close();
      }
    },
    cancelFeeSetting() {
      this.showSetFee = false;
    },
    //课时设置
    //选择课程时间段
    handleTimeRangeChange(value) {
      if (!value) {
        return;
      }
      console.log("value:", value);
      // console.log("this.timeRange:", this.timeRange);

      if (this.selectedPeriods.includes(value[0] + "-" + value[1])) {
        alert("该时间段已选择");
        return;
      }
      this.selectedPeriods.push(value[0] + "-" + value[1]);
      console.log("选择的时间段:", this.selectedPeriods);
      this.selectedTimeRangeStr = "";
      for (let i in this.selectedPeriods) {
        this.selectedTimeRangeStr = this.selectedTimeRangeStr + this.selectedPeriods[i] + "/";
      }
    },
    // 时间选择器获得焦点时触发（通常在点击展开时）
    handleTimePickerFocus() {
      console.log("时间选择器已展开");
      console.log("this.timeRange:", this.timeRange);
      this.timePickerFocus = true;
      this.showSelectedTimeRange = true;
    },
    handleTimePickerBlur() {
      console.log("时间选择器已收起");
      console.log("this.timeRange:", this.timeRange);
      this.timePickerFocus = false;

      // 如果进入展示时间段页面，就不用取消展示时间段页面
      if (this.enterTimeRangeShowPage) {
        this.enterTimeRangeShowPage = false;
        return;
      }
      this.showSelectedTimeRange = false;
    },
    handleTimeRangeShowPageEnter() {
      this.enterTimeRangeShowPage = true;
      this.showSelectedTimeRange = true;
    },
    handleTimeRangeShowPageLeave() {
      console.log("handleTimeRangeShowPageLeave");
      this.enterTimeRangeShowPage = false;

      // console.log("this.timePickerFocus:", this.timePickerFocus);
      // 离开展示时间段的页面，如果时间段选择器没展开，取消展示时间段页面
      if (!this.timePickerFocus) {
        this.showSelectedTimeRange = false;
      }
    },
    async deleteTimeRange(index) {
      //判断删除的时间段，是否已安排课程
      if (this.addClassTag == "modify") {
        let period = this.selectedPeriods[index];
        const loading = ElLoading.service({
          lock: true,
          text: "处理中...",
          background: "rgba(0, 0, 0, 0.7)"
        });
        try {
          let params = {
            period: period,
            classId: this.classList[this.selectedClassIndex].id
          };
          let resp1 = await axios.post("https://backend.wonology.com/courseArrange/courseArrange/ifPeriodHasCourse", params);
          if (resp1.data.code == "0000") {
            if (resp1.data.data == true) {
              alert(`时间段'${period}'已安排课程，不能删除该时间段`);
              return;
            }
          } else {
            console.log("调用ifPeriodHasCourse出错:", resp1.data.msg);
            alert("调用后端出错: " + resp1.data.msg);
          }
        } catch (error) {
          console.log("调用后端出错:", error);
          alert("调用后端出错: " + error);
        } finally {
          loading.close();
        }
      }
      this.selectedPeriods.splice(index, 1);
      this.selectedTimeRangeStr = "";
      for (let i in this.selectedPeriods) {
        this.selectedTimeRangeStr = this.selectedTimeRangeStr + this.selectedPeriods[i] + "/";
      }
    },
    openTimePicker() {
      // 通过ref调用时间选择器的focus方法来展开它
      this.$refs.timePickerRef.focus();
    },
    //老师课表 页面
    //选择日期
    clickTeacherCourseDate(index) {
      this.teacherCourseSelectedDateIndex = index;
    },
    //切换老师，获取老师的课程安排
    async handleTeacherChange() {
      const t0 = Date.now();
      await this.getTeacherCourseArrange();
      const dtTeacherCourse = Date.now() - t0;
      if (dtTeacherCourse > SLOW_STEP_LOG_MS) {
        console.log(`获取老师课程安排用时： ${dtTeacherCourse}ms (>${SLOW_STEP_LOG_MS}ms)`);
      }
    },
    //双击日期， 给老师排课
    async doubleClickTeacherCourseDate(index) {
      {
        const t0 = Date.now();
        // 获取老师参与的班级
        await this.getTeacherClass();
        const dtTeacherClass = Date.now() - t0;
        if (dtTeacherClass > SLOW_STEP_LOG_MS) {
          console.log(`获取老师参与的班级用时： ${dtTeacherClass}ms (>${SLOW_STEP_LOG_MS}ms)`);
        }
      }

      //重置变量
      this.selectedClassId = "";
      this.selectedCourse = "";
      this.selectedPeriod = "";
      this.selectedClassroomId = "";
      this.teacherCourseSelectedDateIndex = index;
      this.showTeacherAddCourse = true;
    },
    //老师排课确定
    async teacherCourseArrangeConfirm() {
      let selectedDate = this.monthDates[this.teacherCourseSelectedDateIndex].completeDate;
      let selectedClassIndex = this.classList.findIndex(item => item.id == this.selectedClassId);

      // 判断日期是否超过班级结班日期
      if (selectedDate > this.classList[selectedClassIndex].endDate) {
        this.showTip = true;
        this.tipMessage = `当前日期已超过班级结班日期，是否继续排课？结班日期会自动改为当前日期。`;

        // 注册resolve函数 （和回调还是有点区别，不过这个方法更好）
        // 后面通过 this.tipResolver(value) 返回值
        const tipConfirmed = await new Promise(resolve => {
          this.tipResolver = resolve;
        });
        if (tipConfirmed === "confirm") {
          // 用户选择确认，继续执行
        } else {
          // 用户选择取消，返回

          return;
        }
      }

      // 判断日期是否早于班级开班日期
      if (selectedDate < this.classList[selectedClassIndex].startDate) {
        this.showTip = true;
        this.tipMessage = `当前日期早于班级开班日期，是否继续排课？开班日期会自动改为当前日期。`;

        // 注册resolve函数 （和回调还是有点区别，不过这个方法更好）
        // 后面通过 this.tipResolver(value) 返回值
        const tipConfirmed = await new Promise(resolve => {
          this.tipResolver = resolve;
        });
        if (tipConfirmed === "confirm") {
          // 用户选择确认，继续执行
        } else {
          // 用户选择取消，返回

          return;
        }
      }

      // 如果不是move，判断是否超过班级已排课时
      if (this.addCourseArrangeFlag != "move") {
        let courseMinutes = this.calculateTimeDuration(this.selectedPeriod).totalMinutes;
        let arrangedHour = this.classList[this.selectedClassIndex].arrangedHour;
        if (arrangedHour + parseFloat((courseMinutes / 60).toFixed(2)) > this.classList[this.selectedClassIndex].totalHour) {
          this.showTip = true;
          this.tipMessage = `排课课时超过班级设置的总课时，是否继续？`;

          // 注册resolve函数 （和回调还是有点区别，不过这个方法更好）
          // 后面通过 this.tipResolver(value) 返回值
          const tipConfirmed = await new Promise(resolve => {
            this.tipResolver = resolve;
          });
          if (tipConfirmed === "confirm") {
            // 用户选择确认，继续执行

            this.showTip = false;
            // 重置变量
            this.tipMessage = "";
            this.tipNeedInput = false;
          } else {
            // 用户选择取消，返回

            return;
          }
        }
      }

      //loading界面
      const loading = ElLoading.service({
        lock: true,
        text: "处理中...",
        background: "rgba(0, 0, 0, 0.7)"
      });
      try {
        if (!(this.selectedClassId && this.selectedCourse && this.selectedPeriod && this.selectedClassroomId)) {
          alert("请选择班级，科目，时间，教室");
          return;
        }
        let params = {
          addCourseArrangeFlag: this.addCourseArrangeFlag,
          classId: this.selectedClassId,
          selectedDate: this.monthDates[this.teacherCourseSelectedDateIndex].completeDate,
          selectedPeriod: this.selectedPeriod,
          selectedTeacherId: this.teacherList[this.selectedTeacherIndex].id,
          selectedClassroomId: this.selectedClassroomId,
          selectedCourse: this.selectedCourse,
          username: this.username
        };
        //如果是移动，额外处理一些东西
        if (this.addCourseArrangeFlag == "move") {
          params.dragStartDate = this.dragStartDate;
          params.dragStartPeriod = this.classList[this.selectedClassIndex].periods[this.dragStartIndexs[1]];
        }
        let resp1 = await axios.post("https://backend.wonology.com/courseArrange/courseArrange/addCourseArrange", params);
        if (resp1.data.code == "0000") {
          this.showTeacherAddCourse = false;

          //获取老师的课程安排
          await this.getTeacherCourseArrange();
          await this.getClassCourseArrange();
          if (this.studentList.length > 0) {
            await this.getStudentCourseArrange();
          }
        } else {
          console.log("调用addCourseArrange出错:", resp1.data.msg);
          alert("调用后端出错: " + resp1.data.msg);
        }
      } catch (error) {
        console.log("catch error:", error);
        alert("catch error " + error);
      } finally {
        loading.close();
      }
    },
    teacherCourseArrangeCancel() {
      this.showTeacherAddCourse = false;
    },
    //选择班级后 做的事情
    selectClass() {
      //找出这个老师，在这个班级 教授的科目
      const classIndex = this.classList.findIndex(classObj => classObj.id === this.selectedClassId);
      this.teacherClassCourseList = [];
      for (let i in this.teacherList[this.selectedTeacherIndex].courses) {
        if (this.classList[classIndex].courses.includes(this.teacherList[this.selectedTeacherIndex].courses[i])) {
          this.teacherClassCourseList.push(this.teacherList[this.selectedTeacherIndex].courses[i]);
        }
      }
      console.log("this.teacherClassCourseList:", this.teacherClassCourseList);

      //选择班级后，判断班级的时间段哪些可用
      this.selectedClassIndex = classIndex;
      this.teacherPeriodIsFree = this.ifTeacherPeriodIsFree(this.classList[this.selectedClassIndex].id, this.teacherList[this.selectedTeacherIndex].id, this.monthDates[this.teacherCourseSelectedDateIndex].completeDate, this.classList[this.selectedClassIndex].periods);
    },
    // 判断老师某天的时间段是否空闲
    ifTeacherPeriodIsFree(classId, teacherId, date, periods) {
      let ret = {};

      //每个时间段
      for (let i = 0; i < periods.length; i++) {
        let period = periods[i];
        ret[period] = 1;
        let periodStartTime = period.split("-")[0];
        let periodEndTime = period.split("-")[1];

        // 和该班级当天已安排课程比较
        if (this.courseArrangeList[date]) {
          for (let arrangedPeriod in this.courseArrangeList[date]) {
            let arrangedPeriodStartTime = arrangedPeriod.split("-")[0];
            let arrangedPeriodEndTime = arrangedPeriod.split("-")[1];

            //判断起止时间是否在时间段内
            if (periodStartTime >= arrangedPeriodStartTime && periodStartTime < arrangedPeriodEndTime) {
              ret[period] = 0;
              break;
            }
            if (periodEndTime > arrangedPeriodStartTime && periodEndTime <= arrangedPeriodEndTime) {
              ret[period] = 0;
              break;
            }
            // 如果起止时间都不在时间段内，判断是不是包含
            if (periodStartTime <= arrangedPeriodStartTime && periodEndTime >= arrangedPeriodEndTime) {
              ret[period] = 0;
              break;
            }
          }
        }

        // 和老师休假比较
        if (this.vacationList[teacherId][date]) {
          let arrangedPeriodStartTime = this.vacationList[teacherId][date][0].toString().padStart(2, "0") + ":00";
          let arrangedPeriodEndTime = this.vacationList[teacherId][date][1].toString().padStart(2, "0") + ":00";

          //判断起止时间是否在时间段内
          if (periodStartTime >= arrangedPeriodStartTime && periodStartTime < arrangedPeriodEndTime) {
            ret[period] = 0;
            continue;
          }
          if (periodEndTime > arrangedPeriodStartTime && periodEndTime <= arrangedPeriodEndTime) {
            ret[period] = 0;
            continue;
          }
          // 如果起止时间都不在时间段内，判断是不是包含
          if (periodStartTime <= arrangedPeriodStartTime && periodEndTime >= arrangedPeriodEndTime) {
            ret[period] = 0;
            continue;
          }
        }

        // 和当天老师已安排课比较
        if (this.teacherCourseArrangeList[date]) {
          // 每个安排的课
          for (let arrangedPeriod in this.teacherCourseArrangeList[date]) {
            let arrangedPeriodStartTime = arrangedPeriod.split("-")[0];
            let arrangedPeriodEndTime = arrangedPeriod.split("-")[1];

            //判断起止时间是否在时间段内
            if (periodStartTime >= arrangedPeriodStartTime && periodStartTime < arrangedPeriodEndTime) {
              ret[period] = 0;
              break;
            }
            if (periodEndTime > arrangedPeriodStartTime && periodEndTime <= arrangedPeriodEndTime) {
              ret[period] = 0;
              break;
            }
            // 如果起止时间都不在时间段内，判断是不是包含
            if (periodStartTime <= arrangedPeriodStartTime && periodEndTime >= arrangedPeriodEndTime) {
              ret[period] = 0;
              break;
            }
          }
        }
      }
      return ret;
    },
    // 选择时间段后，判断教室是否可用
    // 老师是否有空
    async selectPeriod() {
      //loading界面
      const loading = ElLoading.service({
        lock: true,
        text: "处理中...",
        background: "rgba(0, 0, 0, 0.7)"
      });
      try {
        //获取有空的教室
        //找出班级对应的校区index
        const campusIndex = this.campusList.findIndex(item => item.campus.id == this.classList[this.selectedClassIndex].campusId);
        //获取教室id列表
        let classroomIdList = [];
        for (let i = 0; i < this.campusList[campusIndex].classrooms.length; i++) {
          classroomIdList.push(this.campusList[campusIndex].classrooms[i].id);
        }
        let params = {
          classroomIdList: classroomIdList,
          selectedDate: this.monthDates[this.teacherCourseSelectedDateIndex].completeDate,
          selectedPeriod: this.selectedPeriod
        };
        let resp1 = await axios.post("https://backend.wonology.com/courseArrange/courseArrange/queryClassroomIfFree", params);
        if (resp1.data.code == "0000") {
          this.classroomIfAvailable = resp1.data.data;
          console.log("this.classroomIfAvailable:", this.classroomIfAvailable);
        } else {
          console.log("调用queryClassroomIfFree出错:", resp1.data.msg);
          alert("调用后端出错: " + resp1.data.msg);
        }

        //获取有空的老师
        let teacherIdList = [];
        for (let i = 0; i < this.teacherList.length; i++) {
          // 只能选该班级中的老师
          if (this.classList[this.selectedClassIndex].teacherIds.includes(this.teacherList[i].id)) {
            teacherIdList.push(this.teacherList[i].id);
          }
        }
        params = {
          teacherIdList: teacherIdList,
          selectedDate: this.monthDates[this.teacherCourseSelectedDateIndex].completeDate,
          selectedPeriod: this.selectedPeriod
        };
        resp1 = await axios.post("https://backend.wonology.com/courseArrange/courseArrange/queryTeacherIfFree", params);
        if (resp1.data.code == "0000") {
          this.teacherIdListAvailable = resp1.data.data;
          console.log("this.teacherIdListAvailable:", this.teacherIdListAvailable);
        } else {
          console.log("调用后端queryTeacherIfFree出错:", resp1.data.msg);
          alert("调用后端出错: " + resp1.data.msg);
        }
      } catch (err) {
        console.log("catch error: " + err);
        alert("catch error: " + err);
      } finally {
        loading.close();
      }
    },
    //老师批量调课
    async clickQuickMoveTeacherCourse() {
      this.teacherCourseSelectedDateIndex = 0;

      //初始开始日期为当天
      this.quickMoveTeacherCourseStartDate = this.todayDate;

      // 得到老师某个日期段有哪些班级，科目
      await this.getTeacherClassCourses();
      this.showQuickMoveTeacherCourse = true;
      // 隐藏菜单栏
      document.getElementById("menu").style.display = "none";
    },
    // 得到老师某个日期段有哪些班级，科目
    async getTeacherClassCourses() {
      //loading界面
      const loading = ElLoading.service({
        lock: true,
        text: "处理中...",
        background: "rgba(0, 0, 0, 0.7)"
      });
      try {
        let params = {
          teacherId: this.teacherList[this.selectedTeacherIndex].id,
          startDate: this.quickMoveTeacherCourseStartDate,
          endDate: this.quickMoveTeacherCourseEndDate
        };
        let resp1 = await axios.post("https://backend.wonology.com/courseArrange/courseArrange/getTeacherClassCourses", params);
        if (resp1.data.code == "0000") {
          this.teacherClassCourses = resp1.data.data;
          console.log("this.teacherClassCourses:", this.teacherClassCourses);
        } else {
          console.log("调用后端出错:", resp1.data.msg);
          alert("调用后端出错: " + resp1.data.msg);
        }
      } catch (error) {
        console.log("catch error:", error);
        alert("catch error " + error);
      } finally {
        loading.close();
      }
    },
    // 修改调课时间段
    async quickMoveTeacherCourseStartDateChange() {
      await this.getTeacherClassCourses();
    },
    async quickMoveTeacherCourseEndDateChange() {
      await this.getTeacherClassCourses();
    },
    // 选择班级和科目，找出可以教这些科目的老师
    quickMoveTeacherCourseSelectedClassIdAndCourseChange() {
      console.log("this.quickMoveTeacherCourseSelectedClassIdAndCourse:", this.quickMoveTeacherCourseSelectedClassIdAndCourse);

      //重置变量
      this.moveToTeacherId = 0;
      this.moveToTeacherList = [];
      this.moveToTeacherCourseNum = 0;
      this.moveToTeacherRestNum = 0;

      //选择了哪个科目
      let course = this.quickMoveTeacherCourseSelectedClassIdAndCourse.split("_")[1];

      // 获取选择的科目，有哪些老师可以教
      this.moveToTeacherList = [];
      for (let i in this.teacherList) {
        if (this.teacherList[i].coursesStr.includes(course)) {
          // 排除自己
          if (this.teacherList[i].id == this.teacherList[this.selectedTeacherIndex].id) {
            continue;
          }
          this.moveToTeacherList.push(this.teacherList[i]);
        }
      }
      console.log("this.moveToTeacherList:", this.moveToTeacherList);
    },
    // 选择班级和科目
    selectClassIdAndCourse(classId, course) {
      this.quickMoveTeacherCourseSelectedClassIdAndCourse = classId + "_" + course;
      this.quickMoveTeacherCourseSelectedClassIdAndCourseChange();
    },
    // 选择移到的老师，获取最大可移动的课次，预览调课老师课表
    async handleMoveToTeacherChange() {
      const loading = ElLoading.service({
        lock: true,
        text: "处理中...",
        background: "rgba(0, 0, 0, 0.7)"
      });

      // 选择不同的班级和科目，会重置移到的老师
      if (this.moveToTeacherId == "") {
        // 直接返回，不用后面的步骤
        return;
      }
      try {
        // 获取移到的老师最大可移动的课次
        let classId = parseInt(this.quickMoveTeacherCourseSelectedClassIdAndCourse.split("_")[0]);
        let course = this.quickMoveTeacherCourseSelectedClassIdAndCourse.split("_")[1];
        let params = {
          teacherId: this.moveToTeacherId,
          courseList: this.teacherClassCourses[classId][course]
        };
        let resp1 = await axios.post("https://backend.wonology.com/courseArrange/courseArrange/courseIfCanMove", params);
        if (resp1.data.code == "0000") {
          this.courseIfCanMove = resp1.data.data;

          // console.log("this.courseIfCanMove:", this.courseIfCanMove);

          if (this.quickMoveTeacherCourseEndDate == "" || this.quickMoveTeacherCourseEndDate == null) {
            this.realEndDate = resp1.data.endDate;
          }
          this.courseCanMove = [];
          this.courseCannotMove = [];
          for (let i in this.courseIfCanMove) {
            if (this.courseIfCanMove[i].isConflict == true) {
              this.courseCannotMove.push(this.courseIfCanMove[i]);
            } else {
              this.courseCanMove.push(this.courseIfCanMove[i]);
            }
          }

          // 分配课次默认最大
          this.moveToTeacherCourseNum = this.courseCanMove.length;
        } else {
          console.log("调用courseIfCanArrange出错:", resp1.data.msg);
          alert("调用后端出错: " + resp1.data.msg);
        }

        // 获取移到的老师课表
        let endDate = this.quickMoveTeacherCourseEndDate;
        if (this.quickMoveTeacherCourseEndDate == "" || this.quickMoveTeacherCourseEndDate == null) {
          endDate = this.realEndDate;
        }
        console.log("endDate:", endDate);
        params = {
          teacherId: this.moveToTeacherId,
          startDate: this.quickMoveTeacherCourseStartDate,
          endDate: endDate
        };
        resp1 = await axios.post("https://backend.wonology.com/courseArrange/courseArrange/getTeacherCourseArrange", params);
        if (resp1.data.code == "0000") {
          this.moveToTeacherCourseArrangeList = resp1.data.data;
          this.oriMoveToTeacherCourseArrangeList = resp1.data.data;
          console.log("this.moveToTeacherCourseArrangeList:", this.moveToTeacherCourseArrangeList);
        } else {
          console.log("调用 getTeacherCourseArrange 出错:", resp1.data.msg);
          alert("调用后端出错: " + resp1.data.msg);
        }

        // 分配给老师的课次变化，计算剩余待分配课次，左边预览课程也变化
        this.handleMoveToTeacherCourseNumChange();
      } catch (error) {
        console.log("调用后端出错:", error);
        alert("调用后端出错: " + error);
      } finally {
        loading.close();
      }
    },
    // 分配给老师的课次变化，计算剩余待分配课次，左边预览课程也变化
    handleMoveToTeacherCourseNumChange() {
      // 计算剩余待分配课次
      this.moveToTeacherRestNum = this.courseCanMove.length + this.courseCannotMove.length - this.moveToTeacherCourseNum;

      // 重置变量
      this.moveCourseList = [];
      this.moveToTeacherCourseArrangeList = JSON.parse(JSON.stringify(this.oriMoveToTeacherCourseArrangeList));
      // 调课的日期段
      let endDate = this.quickMoveTeacherCourseEndDate;
      if (this.quickMoveTeacherCourseEndDate == "" || this.quickMoveTeacherCourseEndDate == null) {
        endDate = this.realEndDate;
      }
      console.log("endDate:", endDate);
      this.monthDates = this.getCompleteDateRange(this.quickMoveTeacherCourseStartDate, endDate);

      // 老师课表加上要移动的课程
      for (let i = 0; i < this.moveToTeacherCourseNum; i++) {
        this.moveCourseList.push(this.courseCanMove[i]);
        if (!this.moveToTeacherCourseArrangeList[this.courseCanMove[i].date]) {
          this.moveToTeacherCourseArrangeList[this.courseCanMove[i].date] = {};
        }
        this.moveToTeacherCourseArrangeList[this.courseCanMove[i].date][this.courseCanMove[i].period] = this.courseCanMove[i];

        // 如果这个日期移进了课，标记粉色
        for (let j in this.monthDates) {
          if (this.monthDates[j].completeDate == this.courseCanMove[i].date) {
            this.monthDates[j].isMoved = true;
            break;
          }
        }
      }
      console.log("this.moveToTeacherCourseArrangeList:", this.moveToTeacherCourseArrangeList);
    },
    //关闭老师批量调课页面
    cancelQuickMoveTeacherCourse() {
      this.showQuickMoveTeacherCourse = false;

      // 显示菜单栏
      document.getElementById("menu").style.display = "block";

      // 重置变量
      this.quickMoveTeacherCourseSelectedClassIdAndCourse = "";
      this.moveToTeacherList = [];
      this.moveToTeacherId = 0;
      this.ifAssignRest = true;
      this.moveToTeacherCourseNum = 0;
      this.moveToTeacherRestNum = 0;

      // 重置日期段
      this.getMonthInfo();

      // 恢复今天的日期蓝色框
      for (let i = 0; i < this.monthDates.length; i++) {
        if (this.monthDates[i].completeDate === this.todayDate) {
          this.teacherCourseSelectedDateIndex = parseInt(JSON.stringify(i));
          break;
        }
      }
    },
    //老师批量调课页面下一步，剩余课次分配
    async quickMoveTeacherCourseNextStep() {
      const loading = ElLoading.service({
        lock: true,
        text: "处理中...",
        background: "rgba(0, 0, 0, 0.7)"
      });
      try {
        // 如果没有剩余待分配课次，不需要下一步，调用后端修改这些课程上课老师
        if (this.moveToTeacherRestNum == 0) {
          if (this.moveToTeacherCourseNum == 0) {
            alert("请选择要分配给老师的课次");
            return;
          }
          let courseList = [];
          for (let i = 0; i < this.moveToTeacherCourseNum; i++) {
            courseList.push(this.courseCanMove[i]);
          }
          await this.moveCourseToTeacher(courseList);
          this.cancelQuickMoveTeacherCourse();
          return;
        }
        // 如果没勾选分配剩余课次，直接调用后端修改这些课程上课老师
        if (this.ifAssignRest == false) {
          if (this.moveToTeacherCourseNum == 0) {
            alert("请选择要分配给老师的课次");
            return;
          }
          let courseList = [];
          for (let i = 0; i < this.moveToTeacherCourseNum; i++) {
            courseList.push(this.courseCanMove[i]);
          }
          await this.moveCourseToTeacher(courseList);
          this.cancelQuickMoveTeacherCourse();
          return;
        }

        // 如果需要分配剩余课次，下一步
        else {
          // this.cancelQuickMoveTeacherCourse()

          // 获取要移动的班级，是周几，哪些时间段上课
          let classId = parseInt(this.quickMoveTeacherCourseSelectedClassIdAndCourse.split("_")[0]);
          let course = this.quickMoveTeacherCourseSelectedClassIdAndCourse.split("_")[1];
          this.quickMoveTeacherCourseSelectedClassId = classId;
          this.quickMoveTeacherCourseSelectedCourse = course;
          this.classWeekdays = [];
          this.classPeriods = [];
          for (let i in this.teacherClassCourses[classId][course]) {
            let dateObj = new Date(this.teacherClassCourses[classId][course][i].date);
            let dayOfWeek = dateObj.getDay(); //0-6 0表示星期天
            let weekdayIndex = dayOfWeek == 0 ? 6 : dayOfWeek - 1;
            let weekday = this.weekdays[weekdayIndex];
            if (!this.classWeekdays.includes(weekday)) {
              this.classWeekdays.push(weekday);
            }
            if (!this.classPeriods.includes(this.teacherClassCourses[classId][course][i].period)) {
              this.classPeriods.push(this.teacherClassCourses[classId][course][i].period);
            }
          }

          // 剩余课次分配日期段的开始日期，默认当天
          this.teacherRestCourseMoveStartDate = this.todayDate;
          // 调课的结束日期
          let endDate = this.quickMoveTeacherCourseEndDate;
          if (this.quickMoveTeacherCourseEndDate == "" || this.quickMoveTeacherCourseEndDate == null) {
            endDate = this.realEndDate;
          }
          // 要移动的班级，结班日期，取结班日期和最后一次课更晚的时间作为 剩余课次分配日期段的结束日期
          let classIndex = this.classList.findIndex(classObj => classObj.id === classId);
          if (this.classList[classIndex].endDate > endDate) {
            this.teacherRestCourseMoveEndDate = this.classList[classIndex].endDate;
          } else {
            this.teacherRestCourseMoveEndDate = endDate;
          }

          //查询一个日期时间段的每个日期，每个时间段，每个老师，是否可以排课
          await this.queryDatePeriodIfAvailable();

          // 显示 剩余课次分配 页面
          this.showQuickMoveTeacherCourseStep2 = true;
        }
      } catch (error) {
        console.log("catch error:", error);
        alert("catch error: " + error);
      } finally {
        loading.close();
      }
    },
    //查询一个日期时间段的每个日期，每个时间段，每个老师，是否可以排课
    async queryDatePeriodIfAvailable() {
      const loading = ElLoading.service({
        lock: true,
        text: "处理中...",
        background: "rgba(0, 0, 0, 0.7)"
      });
      try {
        // 获取班级index
        let classIndex = this.classList.findIndex(classObj => classObj.id === this.quickMoveTeacherCourseSelectedClassId);
        //找出班级对应的 校区index
        const campusIndex = this.campusList.findIndex(item => item.campus.id == this.classList[classIndex].campusId);
        //获取教室id列表
        let classroomIdList = [];
        for (let i = 0; i < this.campusList[campusIndex].classrooms.length; i++) {
          classroomIdList.push(this.campusList[campusIndex].classrooms[i].id);
        }
        // 组成 selectedWeekdayPeriods 参数
        let selectedWeekdayPeriods = [];
        for (let weekdayIndex in this.weekdays) {
          for (let periodIndex in this.classPeriods) {
            if (selectedWeekdayPeriods[weekdayIndex] == null) {
              selectedWeekdayPeriods[weekdayIndex] = [];
            }
            selectedWeekdayPeriods[weekdayIndex].push(this.classPeriods[periodIndex]);
          }
        }
        //查询一个日期时间段的每个日期，每个时间段，每个老师，是否可以排课
        let params = {
          classId: this.quickMoveTeacherCourseSelectedClassId,
          quickArrangeDateRange: [this.teacherRestCourseMoveStartDate, this.teacherRestCourseMoveEndDate],
          selectedWeekdayPeriods: selectedWeekdayPeriods,
          classroomIdList: classroomIdList,
          teacherIdList: [this.moveToTeacherId]
        };
        let resp1 = await axios.post("https://backend.wonology.com/courseArrange/courseArrange/queryDatePeriodIfAvailable", params);
        if (resp1.data.code == "0000") {
          this.weekdayPeriodTeacherAvailableNum = resp1.data.data.weekdayPeriodTeacherAvailableNum;
          this.teacherDatePeriodIfAvailable = resp1.data.data.teacherDatePeriodIfAvailable;
          console.log("this.weekdayPeriodTeacherAvailableNum:", this.weekdayPeriodTeacherAvailableNum);
          console.log("this.teacherDatePeriodIfAvailable:", this.teacherDatePeriodIfAvailable);
        } else {
          console.log("调用queryDatePeriodIfAvailable出错:", resp1.data.msg);
          alert("调用后端出错: " + resp1.data.msg);
        }

        // 显示 剩余课次分配 页面
        this.showQuickMoveTeacherCourseStep2 = true;
      } catch (error) {
        console.log("catch error:", error);
        alert("catch error: " + error);
      } finally {
        loading.close();
      }
    },
    // 调课给老师
    async moveCourseToTeacher(courseList, restCourseList) {
      //loading界面
      const loading = ElLoading.service({
        lock: true,
        text: "处理中...",
        background: "rgba(0, 0, 0, 0.7)"
      });
      try {
        let params = {
          moveToTeacherId: this.moveToTeacherId,
          courseList: courseList,
          restCourseList: restCourseList,
          username: this.username,
          institution: this.institution
        };
        let resp1 = await axios.post("https://backend.wonology.com/courseArrange/courseArrange/quickMoveTeacherCourse", params);
        if (resp1.data.code == "0000") {
          //获取老师的课程安排
          await this.getTeacherCourseArrange();
          await this.getClassCourseArrange();
          if (this.studentList.length > 0) {
            await this.getStudentCourseArrange();
          }
        } else {
          console.log("调用quickMoveTeacherCourse出错:", resp1.data.msg);
          alert("调用后端出错: " + resp1.data.msg);
        }
      } catch (error) {
        console.log("catch error:", error);
        alert("catch error " + error);
      } finally {
        loading.close();
      }
    },
    async teacherRestCourseMoveStartDateChange() {
      // 如果选择的日期在开班日期前，则提示
      let classId = parseInt(this.quickMoveTeacherCourseSelectedClassIdAndCourse.split("_")[0]);
      let classIndex = this.classList.findIndex(classObj => classObj.id === classId);
      if (this.teacherRestCourseMoveStartDate < this.classList[classIndex].startDate) {
        this.showTip = true;
        this.tipMessage = `是否确认选择开班日期前的日期`;

        // 注册resolve函数 （和回调还是有点区别，不过这个方法更好）
        // 后面通过 this.tipResolver(value) 返回值
        const tipConfirmed = await new Promise(resolve => {
          this.tipResolver = resolve;
        });
        if (tipConfirmed === "confirm") {
          // 用户选择确认，继续执行
        } else {
          // 用户选择取消，返回

          return;
        }
      }
      console.log("111111111");

      //查询一个日期时间段的每个日期，每个时间段，每个老师，是否可以排课
      await this.queryDatePeriodIfAvailable();
      console.log("222222");

      // 重置勾选的周几和时间段
      this.weekdayPeriodIfSelected = [[], [], [], [], [], [], []];
      this.weekdayAvailable = [0, 0, 0, 0, 0, 0, 0];
      this.weekdayAvailableRest = [0, 0, 0, 0, 0, 0, 0];
      this.weekdayAssign = [0, 0, 0, 0, 0, 0, 0];
    },
    async teacherRestCourseMoveEndDateChange() {
      // 如果选择的日期在结班日期后，则提示
      let classId = parseInt(this.quickMoveTeacherCourseSelectedClassIdAndCourse.split("_")[0]);
      let classIndex = this.classList.findIndex(classObj => classObj.id === classId);
      if (this.teacherRestCourseMoveEndDate > this.classList[classIndex].endDate) {
        this.showTip = true;
        this.tipMessage = `是否确认选择结班日期后的日期`;

        // 注册resolve函数 （和回调还是有点区别，不过这个方法更好）
        // 后面通过 this.tipResolver(value) 返回值
        const tipConfirmed = await new Promise(resolve => {
          this.tipResolver = resolve;
        });
        if (tipConfirmed === "confirm") {
          // 用户选择确认，继续执行
        } else {
          // 用户选择取消，返回

          return;
        }
      }

      //查询一个日期时间段的每个日期，每个时间段，每个老师，是否可以排课
      await this.queryDatePeriodIfAvailable();

      // 重置勾选的周几和时间段
      this.weekdayPeriodIfSelected = [[], [], [], [], [], [], []];
      this.weekdayAvailable = [0, 0, 0, 0, 0, 0, 0];
      this.weekdayAvailableRest = [0, 0, 0, 0, 0, 0, 0];
      this.weekdayAssign = [0, 0, 0, 0, 0, 0, 0];
    },
    // 勾选了周几和时间段，计算这几天可排课次合计，剩余可分配课次
    async selectWeekdayPeriod(weekdayIndex, periodIndex) {
      // 如果选择的周几不是班级上课的周几，提示
      if (this.weekdayPeriodIfSelected[weekdayIndex][periodIndex] == true) {
        let weekday = this.weekdays[weekdayIndex];
        if (!this.classWeekdays.includes(weekday)) {
          this.showTip = true;
          this.tipMessage = "该班级不在" + weekday + "上课，是否确认选择?";

          // 注册resolve函数 （和回调还是有点区别，不过这个方法更好）
          // 后面通过 this.tipResolver(value) 返回值
          const tipConfirmed = await new Promise(resolve => {
            this.tipResolver = resolve;
          });
          if (tipConfirmed === "confirm") {
            // 用户选择确认，继续执行
          } else {
            // 用户选择取消，重置，返回
            this.weekdayPeriodIfSelected[weekdayIndex][periodIndex] = false;
            return;
          }
        }
      }

      // 选择了哪几天，哪些时间段，计算这几天可排课次合计
      this.weekdayAvailable = [0, 0, 0, 0, 0, 0, 0];
      for (let weekdayIndex in this.weekdayPeriodIfSelected) {
        for (let periodIndex in this.weekdayPeriodIfSelected[weekdayIndex]) {
          let period = this.classPeriods[periodIndex];
          // console.log("period:", period);

          if (this.weekdayPeriodIfSelected[weekdayIndex][periodIndex] == true) {
            this.weekdayAvailable[weekdayIndex] = this.weekdayAvailable[weekdayIndex] + this.weekdayPeriodTeacherAvailableNum[weekdayIndex][period][this.moveToTeacherId];
          }
        }
      }

      // 如果是取消选中，分配课次重置0
      if (this.weekdayPeriodIfSelected[weekdayIndex][periodIndex] == false) {
        this.weekdayAssign[weekdayIndex] = 0;
      }

      // 选择了哪几天，计算这几天 剩余可分配课次
      let alreadyAssign = 0;
      for (let weekdayIndex in this.weekdayAssign) {
        alreadyAssign = alreadyAssign + this.weekdayAssign[weekdayIndex];
      }
      for (let weekdayIndex in this.weekdayAvailable) {
        this.weekdayAvailableRest[weekdayIndex] = this.weekdayAvailable[weekdayIndex];

        // 取更小的数值
        if (this.weekdayAvailable[weekdayIndex] > this.moveToTeacherRestNum - alreadyAssign + this.weekdayAssign[weekdayIndex]) {
          this.weekdayAvailableRest[weekdayIndex] = this.moveToTeacherRestNum - alreadyAssign + this.weekdayAssign[weekdayIndex];
        }
      }
    },
    // 点击div，触发el-select展开
    openSelectWeekdayAssign(weekdayIndex) {
      const selectElement = this.$refs[`selectWeekdayAssign_${weekdayIndex}`][0];
      console.log("selectElement:", selectElement);
      selectElement.toggleMenu();
      // if (selectElement && selectElement instanceof HTMLSelectElement) {
      //   selectElement.focus();
      // }
    },
    // 周几选择分配的课次，计算每天还剩余可分配课次
    handleWeekdayAssignChange() {
      let moveToTeacherRestNum = this.moveToTeacherRestNum;

      // 计算剩余待分配课次
      for (let weekdayIndex in this.weekdayAssign) {
        moveToTeacherRestNum = moveToTeacherRestNum - this.weekdayAssign[weekdayIndex];
      }

      // 计算每天还剩余可分配课次
      for (let weekdayIndex in this.weekdayAvailableRest) {
        this.weekdayAvailableRest[weekdayIndex] = this.weekdayAssign[weekdayIndex] + moveToTeacherRestNum;

        // 取更小的数值
        if (this.weekdayAvailableRest[weekdayIndex] > this.weekdayAvailable[weekdayIndex]) {
          this.weekdayAvailableRest[weekdayIndex] = this.weekdayAvailable[weekdayIndex];
        }
      }
    },
    // 剩余课次分配 确认
    async teacherRestCourseArrangeConfirm() {
      // 如果分配的课次小于剩余待分配课次，提示是否继续
      let assignedNum = 0;
      for (let weekdayIndex in this.weekdayAssign) {
        assignedNum = assignedNum + this.weekdayAssign[weekdayIndex];
      }
      if (assignedNum < this.moveToTeacherRestNum) {
        this.showTip = true;
        this.tipMessage = "分配的课次小于剩余待分配课次，是否继续?";

        // 注册resolve函数 （和回调还是有点区别，不过这个方法更好）
        // 后面通过 this.tipResolver(value) 返回值
        const tipConfirmed = await new Promise(resolve => {
          this.tipResolver = resolve;
        });
        if (tipConfirmed === "confirm") {
          // 用户选择确认，继续执行
        } else {
          // 用户选择取消，返回

          return;
        }
      }

      // 获取要调整的课程
      let courseList = [];
      let restCourseList = [];
      let restCourseListReal = [];
      let moveCount = 0;
      let restMoveCount = 0;
      for (let i = 0; i < this.courseIfCanMove.length; i++) {
        // 先提出直接分配的课次
        if (moveCount < this.moveToTeacherCourseNum) {
          if (this.courseIfCanMove[i].isConflict != true) {
            courseList.push(this.courseIfCanMove[i]);
            moveCount++;
          } else {
            restCourseList.push(this.courseIfCanMove[i]);
          }
        }
        // 剩下的都放到剩余待分配课次里
        else {
          restCourseList.push(this.courseIfCanMove[i]);
        }
      }

      // 再分配剩余待分配课次
      // 选择的周几，分别有哪些日期
      for (let weekdayIndex in this.weekdayPeriodIfSelected) {
        let weekdayMoveCount = 0;

        // 选择的周几，有哪些日期
        let dates = this.getWeekdayDate(weekdayIndex, this.teacherRestCourseMoveStartDate, this.teacherRestCourseMoveEndDate);

        // 每个日期
        for (let i in dates) {
          if (weekdayMoveCount >= this.weekdayAssign[weekdayIndex]) {
            // 该周几分配的课次已满，跳过
            break;
          }
          let date = dates[i];

          // 每个时间段
          for (let periodIndex in this.weekdayPeriodIfSelected[weekdayIndex]) {
            if (weekdayMoveCount >= this.weekdayAssign[weekdayIndex]) {
              // 该周几分配的课次已满，跳过
              break;
            }

            // 如果周几，时间段被选中，
            if (this.weekdayPeriodIfSelected[weekdayIndex][periodIndex] == true) {
              let period = this.classPeriods[periodIndex];
              console.log("this.teacherDatePeriodIfAvailable:", this.teacherDatePeriodIfAvailable);
              console.log("date:", date);
              console.log("this.teacherDatePeriodIfAvailable[this.moveToTeacherId][date]:", this.teacherDatePeriodIfAvailable[this.moveToTeacherId][date]);

              // 判断该日期，时间段老师是否有空
              if (this.teacherDatePeriodIfAvailable[this.moveToTeacherId][date]) {
                console.log("this.teacherDatePeriodIfAvailable[this.moveToTeacherId][date][period]:", this.teacherDatePeriodIfAvailable[this.moveToTeacherId][date][period]);
                if (this.teacherDatePeriodIfAvailable[this.moveToTeacherId][date][period] == undefined) {
                  // 该日期时间段老师不可用，跳过
                  continue;
                }
              } else {
                // 该日期老师不可用，跳过
                continue;
              }

              // 修改课程的日期，时间段，教室
              restCourseList[restMoveCount].date = date;
              restCourseList[restMoveCount].period = period;
              restCourseList[restMoveCount].classroomId = this.teacherDatePeriodIfAvailable[this.moveToTeacherId][date][period][0];

              // 移动的课程增加
              restCourseListReal.push(restCourseList[restMoveCount]);
              restMoveCount++;
              weekdayMoveCount++;
            }
          }
        }
      }
      console.log("restCourseListReal:", restCourseListReal);

      // 调用后端，修改这些课程上课老师
      this.moveCourseToTeacher(courseList, restCourseListReal);

      // 关闭调课弹窗
      this.showQuickMoveTeacherCourseStep2 = false;
      this.cancelQuickMoveTeacherCourse();
    },
    // 剩余课次分配 取消
    async teacherRestCourseArrangeCancel() {
      this.showQuickMoveTeacherCourseStep2 = false;
    },
    // 获取日期段内周几有哪些日期
    getWeekdayDate(weekdayIndex, startDate, endDate) {
      weekdayIndex = parseInt(weekdayIndex);

      // 将字符串转换为Date对象
      const start = new Date(startDate);
      const end = new Date(endDate);

      // 用monday代替周几
      let firstMonday = new Date(start);
      const dayOfWeek = firstMonday.getDay(); // 0=周日, 1=周一, ..., 6=周六
      console.log("firstMonday:", firstMonday);
      console.log("dayOfWeek:", dayOfWeek);

      // 距离周几的天数
      const daysUntilMonday = (7 + (weekdayIndex + 1) - dayOfWeek) % 7;
      console.log("7 + (weekdayIndex + 1) - dayOfWeek:", 7 + (weekdayIndex + 1) - dayOfWeek);
      console.log("daysUntilMonday:", daysUntilMonday);

      // 找到第一个周几
      firstMonday.setDate(firstMonday.getDate() + daysUntilMonday);
      console.log("firstMonday:", firstMonday);
      const dates = [];
      const current = new Date(firstMonday);

      // 遍历日期段，收集所有周几
      while (current <= end) {
        // 格式化为 YYYY-MM-DD
        const year = current.getFullYear();
        const month = String(current.getMonth() + 1).padStart(2, "0");
        const day = String(current.getDate()).padStart(2, "0");
        const formattedDate = `${year}-${month}-${day}`;
        dates.push(formattedDate);

        // 移动到下一周
        current.setDate(current.getDate() + 7);
      }
      return dates;
    },
    // 新版老师课表/老版老师课表 切换
    chooseTeacherCourseTableNew(flag) {
      this.showTeacherCourseTableNew = flag;
    },
    // 学生课表
    // 切换学生
    async handleStudentChange() {
      const t0 = Date.now();
      if (this.studentList.length > 0) {
        await this.getStudentCourseArrange();
      }
      const dtStudentCourse = Date.now() - t0;
      if (dtStudentCourse > SLOW_STEP_LOG_MS) {
        console.log(`[handleStudentChange] 获取学生课表用时 ${dtStudentCourse}ms (>${SLOW_STEP_LOG_MS}ms)`);
      }
    },
    // 获取学生报名的，一对一的班级
    async getStudentOneToOneClass() {
      const loading = ElLoading.service({
        lock: true,
        text: "处理中...",
        background: "rgba(0, 0, 0, 0.7)"
      });
      try {
        let params = {
          studentId: this.studentList[this.selectedStudentIndex].id
        };
        let resp1 = await axios.post("https://backend.wonology.com/courseArrange/courseArrange/getStudentOneToOneClass", params);
        if (resp1.data.code == "0000") {
          this.studentOneToOneClasses = resp1.data.data;
        } else {
          console.log("调用getStudentOneToOneClass出错:", resp1.data.msg);
          alert("调用后端出错: " + resp1.data.msg);
        }
      } catch (error) {
        console.log("调用后端出错:", error);
        alert("调用后端出错: " + error);
      } finally {
        loading.close();
      }
    },
    // 学生一对一排课 弹窗
    async doubleClickStudentCourseDate(index) {
      await this.getStudentOneToOneClass();

      // 重置变量
      this.selectedClassId = "";
      this.selectedPeriod = "";
      this.selectedTeacherId = "";
      this.selectedClassroomId = "";
      this.selectedCourse = "";
      this.teacherCourseSelectedDateIndex = index;
      this.showStudentAddCourse = true;
    },
    async studentAddCourseArrangeConfirm() {
      //loading界面
      const loading = ElLoading.service({
        lock: true,
        text: "处理中...",
        background: "rgba(0, 0, 0, 0.7)"
      });
      try {
        if (!(this.selectedTeacherId && this.selectedClassroomId && this.selectedCourse)) {
          alert("请选择老师，教室，科目");
          return;
        }
        this.addCourseArrangeFlag = "";
        let params = {
          username: this.username,
          institution: this.institution,
          addCourseArrangeFlag: "",
          classId: this.classList[this.selectedClassIndex].id,
          selectedDate: this.monthDates[this.teacherCourseSelectedDateIndex].completeDate,
          selectedPeriod: this.selectedPeriod,
          selectedTeacherId: this.selectedTeacherId,
          selectedClassroomId: this.selectedClassroomId,
          selectedCourse: this.selectedCourse
        };
        if (this.addCourseArrangeFlag == "move") {
          params.dragStartDate = this.dragStartDate;
          params.dragStartPeriod = this.classList[this.selectedClassIndex].periods[this.dragStartIndexs[1]];
        }
        let resp1 = await axios.post("https://backend.wonology.com/courseArrange/courseArrange/addCourseArrange", params);
        if (resp1.data.code == "0000") {
          this.showStudentAddCourse = false;
          if (this.studentList.length > 0) {
            await this.getStudentCourseArrange();
          }
          await this.getTeacherCourseArrange();
          await this.getClassCourseArrange();

          // 之前的 selectedClassIndex可能是搜索后的classList对应的index，需要找到原来的index
          let classId = this.classList[this.selectedClassIndex].id;

          // 更新班级已排课时, 这里会把classList变为原始的classList
          await this.getClassList();

          // 根据classId找到原来的index
          this.selectedClassIndex = this.classList.findIndex(classObj => classObj.id === classId);
          console.log("this.selectedClassIndex:", this.selectedClassIndex);
        } else {
          console.log("调用addCourseArrange出错:", resp1.data.msg);
          alert("调用后端出错: " + resp1.data.msg);
        }
      } catch (error) {
        console.log("catch error:", error);
        alert("调用后端出错: " + error);
      } finally {
        loading.close();
      }
    },
    studentAddCourseArrangeCancel() {
      this.showStudentAddCourse = false;
    },
    // 选择班级后做的事情
    // 获取班级index
    // 获取班级的上课时间段，学生是否有空
    studentSelectClass() {
      // console.log("selectedClassId:", this.selectedClassId);
      // 获取班级有哪些上课时间段
      this.selectedClassIndex = this.classList.findIndex(classObj => classObj.id === this.selectedClassId);
      // console.log("selectedClassIndex:", this.selectedClassIndex);

      // 获取班级的上课时间段，学生是否有空
      this.getStudentPeriodIsFree("", this.monthDates[this.teacherCourseSelectedDateIndex].completeDate, this.classList[this.selectedClassIndex].periods);
    },
    // 获取学生某个日期，时间段是否有空
    getStudentPeriodIsFree(studentId, date, periods) {
      this.studentPeriodIsFree = {};
      for (let i in periods) {
        this.studentPeriodIsFree[periods[i]] = 1;
      }

      // 如果学生这个日期有课
      if (this.studentCourseArrangeList[date]) {
        // 这天的课的时间段
        for (let period in this.studentCourseArrangeList[date]) {
          for (let i in periods) {
            // 如果时间冲突，置为0
            if (this.periodIsConflict(periods[i], period)) {
              this.studentPeriodIsFree[periods[i]] = 0;
            }
          }
        }
      }
    },
    // 提示弹窗 取消
    closeTip() {
      this.showTip = false;
      this.tipMessage = "";
      if (this.tipResolver) {
        this.tipResolver("cancel");
        this.tipResolver = null;
      }
    },
    confirmTip() {
      this.showTip = false;
      this.tipMessage = "";
      if (this.tipResolver) {
        this.tipResolver("confirm");
        this.tipResolver = null;
      }
    },
    // 选择班级，搜索班级
    search() {
      this.showSearchResult = true;

      // 使用 filter 方法创建新数组，只保留 name 包含 searchStr 的元素
      this.classList = this.oriClassList.filter(item => item.name.includes(this.searchStr));
    },
    cancelSearch() {
      this.searchStr = "";
      this.showSearchResult = false;
      this.classList = JSON.parse(JSON.stringify(this.oriClassList));
    },
    handleMouseEnter() {
      this.showMoreFunction = true;
    },
    handleMouseLeave() {
      this.showMoreFunction = false;
    },
    mouseEnterMoreFunction(index) {
      let el = document.getElementById("moreFunction" + index);
      el.style.background = "#edf1fb";
      el.style.color = "#0d2f89";
    },
    mouseLeaveMoreFunction(index) {
      let el = document.getElementById("moreFunction" + index);
      el.style.background = "none";
      el.style.color = "grey";
    },
    // 显示班级排课详情
    async clickClassDetail() {
      let classId = this.classList[this.selectedClassIndex].id;

      // 只查询这一个班级的已排课时，各科目多少节，已排课时
      await this.getClassList(true, this.classList[this.selectedClassIndex].id);

      // 根据classId找到原来的index
      this.selectedClassIndex = this.classList.findIndex(classObj => classObj.id === classId);
      this.showClassDetail = true;
    },
    cancelClassDetail() {
      this.showClassDetail = false;
    },
    normalizeIdArray(value) {
      if (!value) {
        return [];
      }
      if (Array.isArray(value)) {
        return [...value];
      }
      if (typeof value === "string") {
        try {
          const parsed = JSON.parse(value);
          return Array.isArray(parsed) ? parsed : [];
        } catch (error) {
          console.log("normalizeIdArray parse error:", error, value);
          return [];
        }
      }
      return [];
    },
    getStudentParentPhones(student) {
      let parentPhones = student && student.parentPhones;
      if (typeof parentPhones === "string") {
        try {
          parentPhones = JSON.parse(parentPhones);
        } catch (error) {
          parentPhones = [parentPhones];
        }
      }
      if (!Array.isArray(parentPhones)) {
        parentPhones = [];
      }
      if (student && student.parentPhone) {
        parentPhones.unshift(student.parentPhone);
      }
      return [...new Set(parentPhones.map(phone => String(phone || "").trim()).filter(Boolean))];
    },
    startAddMountStudentParentPhone(studentId) {
      this.editingParentPhoneStudentId = studentId;
      this.newParentPhone = "";
    },
    async saveMountStudentParentPhone(studentId) {
      if (this.parentPhoneSaving) {
        return;
      }
      const phone = this.newParentPhone.trim();
      if (!phone) {
        this.editingParentPhoneStudentId = null;
        return;
      }
      if (!/^1[3-9]\d{9}$/.test(phone)) {
        alert("请输入正确的手机号");
        return;
      }
      const student = this.studentList.find(item => item.id == studentId);
      if (!student) {
        return;
      }
      const parentPhones = this.getStudentParentPhones(student);
      if (student.phone === phone || parentPhones.includes(phone)) {
        alert("该手机号已存在");
        return;
      }
      this.parentPhoneSaving = true;
      try {
        const saved = await this.updateMountStudentParentPhones(student, [...parentPhones, phone]);
        if (saved) {
          this.editingParentPhoneStudentId = null;
          this.newParentPhone = "";
        }
      } finally {
        this.parentPhoneSaving = false;
      }
    },
    async removeMountStudentParentPhone(studentId, phone) {
      const student = this.studentList.find(item => item.id == studentId);
      if (!student) {
        return;
      }
      const parentPhones = this.getStudentParentPhones(student).filter(item => item !== phone);
      await this.updateMountStudentParentPhones(student, parentPhones);
    },
    async updateMountStudentParentPhones(student, parentPhones) {
      const loading = ElLoading.service({
        lock: true,
        text: "处理中...",
        background: "rgba(0, 0, 0, 0.7)"
      });
      try {
        const resp = await axios.post("https://backend.wonology.com/enrollAndClear/enrollment/updateStudentParentPhones", {
          studentId: student.id,
          institution: this.institution,
          parentPhones
        });
        if (resp.data.code != "0000") {
          alert("调用后端出错: " + resp.data.msg);
          return false;
        }
        student.parentPhone = parentPhones[0] || "";
        student.parentPhones = JSON.stringify(parentPhones);
        return true;
      } catch (error) {
        console.log("更新学生联系电话失败:", error);
        alert("更新学生联系电话失败: " + error);
        return false;
      } finally {
        loading.close();
      }
    },
    mergeClassStudentIds(mountStudentIds, studentIds) {
      let mergedIds = [...mountStudentIds];
      for (let i = 0; i < studentIds.length; i++) {
        let studentId = studentIds[i];
        if (!mergedIds.some(id => id == studentId)) {
          mergedIds.push(studentId);
        }
      }
      return mergedIds;
    },
    // 绑定学生，不需要报名
    async mountStudent() {
      this.mountStudentSearchStr = "";

      // 获取已绑定学生
      let mountStudentIds = this.normalizeIdArray(this.classList[this.selectedClassIndex].mountStudentIds);

      // 绑定的学生，加上报名的学生
      let studentIds = this.normalizeIdArray(this.classList[this.selectedClassIndex].studentIds);

      // 去掉重复的
      this.mountStudentIds = this.mergeClassStudentIds(mountStudentIds, studentIds);

      // console.log("this.mountStudentIds:", this.mountStudentIds);

      this.mountStudentNames = [];
      for (let i = 0; i < this.mountStudentIds.length; i++) {
        this.mountStudentNames.push(this.studentNames[this.mountStudentIds[i]]);
      }
      // console.log("this.mountStudentNames:", this.mountStudentNames);

      const menu = document.getElementById("menu");
      if (menu) {
        menu.style.display = "none";
      }
      this.showMountStudent = true;
    },
    async mountStudentConfirm(studentId) {
      if (!studentId) {
        alert("请选择要绑定的学生");
        return;
      }
      const loading = ElLoading.service({
        lock: true,
        text: "处理中...",
        background: "rgba(0, 0, 0, 0.7)"
      });
      try {
        if (this.mountStudentIds.some(id => id == studentId)) {
          alert("学生已绑定");
          return;
        }
        let params = {
          classId: this.classList[this.selectedClassIndex].id,
          studentId
        };
        let resp1 = await axios.post("https://backend.wonology.com/courseArrange/courseArrange/classMountStudent", params);
        if (resp1.data.code == "0000") {
          // 更新班级已绑定学生
          if (!this.classList[this.selectedClassIndex].mountStudentIds) {
            this.classList[this.selectedClassIndex].mountStudentIds = [];
          }
          this.classList[this.selectedClassIndex].mountStudentIds = this.normalizeIdArray(this.classList[this.selectedClassIndex].mountStudentIds);
          if (!this.classList[this.selectedClassIndex].mountStudentIds.some(id => id == studentId)) {
            this.classList[this.selectedClassIndex].mountStudentIds.push(studentId);
          }
          if (!this.mountStudentIds.some(id => id == studentId)) {
            this.mountStudentIds.push(studentId);
          }
          let student = this.studentList.find(studentObj => studentObj.id == studentId);
          if (student) {
            this.mountStudentNames.push(student.name);
          }
          this.mountStudentSearchStr = "";
          console.log("this.mountStudentIds:", this.mountStudentIds);
          console.log("this.classList[this.selectedClassIndex].mountStudentIds:", this.classList[this.selectedClassIndex].mountStudentIds);
        } else {
          console.log("调用classMountStudent出错:", resp1.data.msg);
          alert("调用后端出错: " + resp1.data.msg);
        }
      } catch (error) {
        console.log("catch error:", error);
        alert("catch error: " + error);
      } finally {
        loading.close();
      }
    },
    async mountStudentAddBySearch() {
      if (!this.mountStudentSearchStr.trim()) {
        alert("请输入学生姓名或手机号");
        return;
      }
      if (this.filteredMountStudentOptions.length == 0) {
        alert("未找到可绑定学生");
        return;
      }
      await this.mountStudentConfirm(this.filteredMountStudentOptions[0].id);
    },
    async unmountStudentConfirm(studentId) {
      if (!studentId) {
        return;
      }
      const realMountStudentIds = this.normalizeIdArray(this.classList[this.selectedClassIndex].mountStudentIds);
      if (!realMountStudentIds.some(id => id == studentId)) {
        alert("报名学生不能在这里删除");
        return;
      }
      const loading = ElLoading.service({
        lock: true,
        text: "处理中...",
        background: "rgba(0, 0, 0, 0.7)"
      });
      try {
        let params = {
          classId: this.classList[this.selectedClassIndex].id,
          studentId
        };
        let resp1 = await axios.post("https://backend.wonology.com/courseArrange/courseArrange/classUnmountStudent", params);
        if (resp1.data.code == "0000") {
          this.classList[this.selectedClassIndex].mountStudentIds = this.normalizeIdArray(this.classList[this.selectedClassIndex].mountStudentIds).filter(id => id != studentId);
          this.mountStudentIds = this.mergeClassStudentIds(this.classList[this.selectedClassIndex].mountStudentIds, this.normalizeIdArray(this.classList[this.selectedClassIndex].studentIds));
          this.mountStudentNames = this.mountStudentIds.map(id => this.studentNames[id]);
        } else {
          console.log("调用classUnmountStudent出错:", resp1.data.msg);
          alert("调用后端出错: " + resp1.data.msg);
        }
      } catch (error) {
        console.log("catch error:", error);
        alert("catch error: " + error);
      } finally {
        loading.close();
      }
    },
    mountStudentDone() {
      this.showMountStudent = false;
      this.mountStudentSearchStr = "";
      const menu = document.getElementById("menu");
      if (menu) {
        menu.style.display = "block";
      }
    },
    mountStudentCancel() {
      this.showMountStudent = false;
      this.mountStudentSearchStr = "";
      const menu = document.getElementById("menu");
      if (menu) {
        menu.style.display = "block";
      }
    },
    handleMountStudentChange() {
      // console.log("selectedStudentIndex:", this.selectedStudentIndex);
    },
    // 导出班级课表
    exportClassCourseArrange() {
      this.showExportClassCourseArrangeDateRange = true;
    },
    // 导出老师课表
    exportTeacherCourseArrange() {
      // console.log("导出老师课表");

      this.showExportClassCourseArrangeDateRange = true;
    },
    exportClassCourseArrangCancel() {
      this.showExportClassCourseArrangeDateRange = false;
    },
    // 获取时间段内 班级的排课/老师的排课
    async exportClassCourseArrangeConfirm() {
      if (this.exportClassCourseArrangeDateRange.length < 2) {
        alert("请选择导出的日期段");
        return;
      }
      let monthDates = this.getMonthInfo(this.exportClassCourseArrangeDateRange);
      // console.log("monthDates:", monthDates);

      // 导出班级课表
      if (this.showWhichCourseTable == "class") {
        // 获取时间段内 班级的排课
        let courseArrangeList = await this.getClassCourseArrange([monthDates[0].completeDate, monthDates[monthDates.length - 1].completeDate]);
        this.exportClassCourseArrangeConfirm_former(courseArrangeList, monthDates);
      }

      // 导出老师课表
      if (this.showWhichCourseTable == "teacher") {
        // 获取时间段内 老师的排课
        let courseArrangeList = await this.getTeacherCourseArrange([monthDates[0].completeDate, monthDates[monthDates.length - 1].completeDate]);
        this.exportTeacherCourseArrangeConfirm_former(courseArrangeList, monthDates);
      }
      this.showExportClassCourseArrangeDateRange = false;
    },
    // 导出班级课表
    exportClassCourseArrangeConfirm_former(courseArrangeList, monthDates) {
      this.selectedClassId = this.classList[this.selectedClassIndex].id;
      if (!courseArrangeList) {
        console.log("使用this.courseArrangeList导出课表");
        courseArrangeList = this.courseArrangeList;
      }
      if (!monthDates) {
        console.log("使用this.monthDates导出课表");
        monthDates = this.monthDates;
      }
      console.log("this.selectedClassId", this.selectedClassId);
      console.log("this.selectedClassIndex:", this.selectedClassIndex);
      // console.log("courseArrangeList:", courseArrangeList);

      try {
        // 准备导出数据
        const exportData = [];

        // 添加表头，班级名
        exportData.push([`班级：${this.classNames[this.selectedClassId]}`]);

        // 遍历数据并添加到导出数组中
        // 每周
        for (let i = 0; i < monthDates.length / 7; i++) {
          // 添加日期一行
          let row = [""];
          // 一周的每个日期
          for (let j = 0; j < 7; j++) {
            let date = monthDates[i * 7 + j].completeDate;
            row.push(date);
          }
          // 添加日期一行
          exportData.push(row);

          // 添加星期几一行
          row = [""];
          // 一周的每个星期几
          for (let j = 0; j < 7; j++) {
            let dayOfWeekText = monthDates[i * 7 + j].dayOfWeekText;
            row.push(dayOfWeekText);
          }
          // 添加星期几一行
          exportData.push(row);

          // console.log("exportData:", exportData);

          // 添加每个上课时间段
          for (let k = 0; k < this.classList[this.selectedClassIndex].periods.length; k++) {
            let period = this.classList[this.selectedClassIndex].periods[k];
            row = [period];

            // console.log("period:", period);

            // 一周的每个日期
            for (let j = 0; j < 7; j++) {
              let date = monthDates[i * 7 + j].completeDate;

              // 如果这个日期，这个时间段 有课
              if (courseArrangeList[date]) {
                if (courseArrangeList[date][period]) {
                  let item = courseArrangeList[date][period];

                  // 老师名（科目）
                  row.push(`${this.teacherNames[item.teacherId]}(${item.course})`);
                }
                // 没课
                else {
                  row.push("");
                }
              }
              // 没课
              else {
                row.push("");
              }
            }
            exportData.push(row);
          }

          // console.log("exportData:", exportData);
          console.log("");
        }

        // 创建工作簿
        const ws = XLSX.utils.aoa_to_sheet(exportData);

        // 设置列宽
        ws["!cols"] = [{
          wch: 20
        }, {
          wch: 20
        }, {
          wch: 20
        }, {
          wch: 20
        }, {
          wch: 20
        }, {
          wch: 20
        }, {
          wch: 20
        }, {
          wch: 20
        }];
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "班级课表");

        // 导出文件
        const fileName = `${this.classNames[this.selectedClassId]}_班级课表.xlsx`;
        XLSX.writeFile(wb, fileName);
        console.log("导出成功");
      } catch (error) {
        console.error("导出失败:", error);
        alert("导出失败: " + error.message);
      }
    },
    // 导出老师课表
    exportTeacherCourseArrangeConfirm_former(courseArrangeList, monthDates) {
      // 获取老师id
      this.selectedTeacherId = this.teacherList[this.selectedTeacherIndex].id;
      if (!courseArrangeList) {
        console.log("使用this.teacherCourseArrangeList导出课表");
        courseArrangeList = this.teacherCourseArrangeList;
      }
      if (!monthDates) {
        console.log("使用this.monthDates导出课表");
        monthDates = this.monthDates;
      }

      // console.log("this.selectedTeacherId", this.selectedTeacherId);
      // console.log("this.selectedTeacherIndex:", this.selectedTeacherIndex);
      // console.log("courseArrangeList:", courseArrangeList);

      try {
        // 准备导出数据
        const exportData = [];

        // 添加表头，老师名
        exportData.push([`老师：${this.teacherNames[this.selectedTeacherId]}`]);

        // 遍历数据并添加到导出数组中
        // 每周
        for (let i = 0; i < monthDates.length / 7; i++) {
          // 添加日期一行
          let row = [""];
          // 一周的每个日期
          for (let j = 0; j < 7; j++) {
            let date = monthDates[i * 7 + j].completeDate;
            row.push(date);
          }
          // 添加日期一行
          exportData.push(row);

          // 添加星期几一行
          row = [""];
          // 一周的每个星期几
          for (let j = 0; j < 7; j++) {
            let dayOfWeekText = monthDates[i * 7 + j].dayOfWeekText;
            row.push(dayOfWeekText);
          }
          // 添加星期几一行
          exportData.push(row);

          // console.log("exportData:", exportData);

          // 添加每个上课时间段
          for (let k = 0; k < this.teacherPeriodList.length; k++) {
            let period = this.teacherPeriodList[k];
            row = [period];

            // console.log("period:", period);

            // 一周的每个日期
            for (let j = 0; j < 7; j++) {
              let date = monthDates[i * 7 + j].completeDate;

              // 如果这个日期，这个时间段 有课
              if (courseArrangeList[date]) {
                if (courseArrangeList[date][period]) {
                  let item = courseArrangeList[date][period];

                  // 班级名（科目）
                  row.push(`${this.classNames[item.classId]}(${item.course})`);
                }
                // 没课
                else {
                  row.push("");
                }
              }
              // 没课
              else {
                row.push("");
              }
            }
            exportData.push(row);
          }

          // console.log("exportData:", exportData);
          console.log("");
        }

        // 创建工作簿
        const ws = XLSX.utils.aoa_to_sheet(exportData);

        // 设置列宽
        ws["!cols"] = [{
          wch: 20
        }, {
          wch: 20
        }, {
          wch: 20
        }, {
          wch: 20
        }, {
          wch: 20
        }, {
          wch: 20
        }, {
          wch: 20
        }, {
          wch: 20
        }];
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "老师课表");

        // 导出文件
        const fileName = `${this.teacherNames[this.selectedTeacherId]}_老师课表.xlsx`;
        XLSX.writeFile(wb, fileName);
        console.log("导出成功");
      } catch (error) {
        console.error("导出失败:", error);
        alert("导出失败: " + error.message);
      }
    }
  }
};